import React, { useEffect, useState } from "react";
import { Modal, Form, Spinner, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Controller, useForm } from "react-hook-form";
import { formatRupees, moneyFormatIndia } from "../../../../../utils/inputsValidation";
import Swal from "sweetalert2";
import { logDOM } from "@testing-library/react";
import { IoInformationCircleOutline } from "react-icons/io5";
import api from "../../../../../utils/api";
import socket from "../../../../../context/socket";

const ExternalInvSwitchModal = ({
  show,
  roomId,
  loading,
  error,
  amcName,
  isEiPortfolio,
  isGenerateEIFormResponse,
  isGenerateSipForm,
  onHide,

  rowKey,
  onActionUpdate,
  setIsActionMessage,

  fetchGetEiFolioData,
}) => {
  console.log("isEiPortfolio", isEiPortfolio, isGenerateSipForm[0],isGenerateEIFormResponse);


  const {
    register,
    handleSubmit,
    reset,
    setError,
    clearErrors,
    formState: { errors, isValid },
    setValue,
    watch,
    control,
  } = useForm({
    // defaultValues: defaultValues || {},
    mode: "onChange",
  });

  const [stopSipSelection, setStopSipSelection] = useState({});

  const [isGoalData, setIsGoalData] = useState([]);
  const [goalDetails, setGoalDetails] = useState({});

  const [isReviewed, setIsReviewed] = useState(0);
  const [isCheckedit, setCheckedit] = useState(0);
  const [sipAction, setSipAction] = useState("");

  const [selectedStartDate, setSelectedStartDate] = useState(null);

  // const [generateEiFormData, setGenerateEiFormData] = useState({});
  const [actionName, setActionName] = useState("");
  const [amcNameList, setAmcNameList] = useState([]);
  // const [showSTP, setShowSTP] = useState("");
  // const [stpRedeemstartDate, setStpRedeemstartDate] = useState(null);
  const [stpRedeemstartDate1, setStpRedeemstartDate_1] = useState(null);
  const [stpRedeemstartDate2, setStpRedeemstartDate_2] = useState(null);


  const generateEiFormData = isGenerateEIFormResponse?.body;
  
  
  
  const isGoalResponse = isGenerateSipForm[0];
  const preGoalName = generateEiFormData?.goalName;
  const preGoalId = generateEiFormData?.goalId;
  const preGoalDetails = isEiPortfolio?.goals_data?.[generateEiFormData?.goalId];
  
  console.log("generateEiFormData",isGoalResponse, generateEiFormData,preGoalDetails);
  // exinvdata

  const selectedAmcHouse = watch("amcHouseRedeem");

  const ActionW = watch("sipaction");
  const allUnitsRedeemW = watch("allUnitsRedeem");
  const transactionAmountRedeemW = watch("transactionAmountRedeem");

  // -----------------Redeem-------------------
  const reInvestW = watch("reInvest");
  const goalNameRedeemW = watch("goalNameRedeem");
  const lumpSumAmountRedeemW = watch("lumpSumAmountRedeem");
  const amcHouseRedeemW = watch("amcHouseRedeem");
  const fundNameRedeemW = watch("fundNameRedeem");
  const redeem_stpW = watch("redeem_stp");
  const STP_FrequencyW = watch("STP_Frequency");
  const stpDurationMonthW = watch("stpDurationMonthRedeem");
  const STP_fundNameW = watch("STP_fundName");

  const redeem_stp1W = watch("redeem_stp1");
  const redeem_stp2W = watch("redeem_stp2");

  const STP_Frequency1W = watch("STP_Frequency1");
  const STP_Frequency2W = watch("STP_Frequency2");

  const stpdurationmonth1W = watch("stpdurationmonth1");
  const stpdurationmonth2W = watch("stpdurationmonth2");

  const STP_fundName1W = watch("STP_fundName1");
  const STP_fundName2W = watch("STP_fundName2");

  const stplumpsumamount1W = watch("stplumpsumamount1");
  const stplumpsumamount1W1 = watch("stplumpsumamount11");
  const stplumpsumamount1W2 = watch("stplumpsumamount12");

  // -----------------Switch-------------------
  const allUnitsSwitchW = watch("allUnitsSwitch");
  
  const transactionAmountSwitchW = watch("transactionAmountSwitch");
  const switchInFundW = watch("switchInFund");
  const stpSwitchW = watch("stpSwitch");
  const stpSwitchFrequencyW = watch("stpSwitchFrequency");
  const stpSwitchDurationW = watch("stpSwitchDuration");
  const stpSwitchlumpSumAmountW = watch("stpSwitchlumpSumAmount");
  // const stplumpsumamount1W1 = watch("stplumpsumamount11");
  // const stplumpsumamount1W2 = watch("stplumpsumamount12");

  const stpSwitchfundNameW = watch("stpSwitchfundName");

  // -----------------STP-------------------
  const frequencySTPW = watch("frequencySTP");
  const durationSTPW = watch("durationSTP");
  const lumpSumAmountSTPW = watch("lumpSumAmountSTP");
  const stpInFundW = watch("stpInFund");

  // -----------------SIP-------------------
  const sipAmountSIPW = watch("sipAmountSIP");
  const goalNameSIPW = watch("goalNameSIP");
  const perpetualSIPW = watch("perpetualSIP");
  // console.log('allUnitsSwitch',allUnitsSwitchW,ActionW,preGoalName,goalNameSIPW);

  // -----------------SIP Stop-------------------
  const startasipW = watch("startasip");
  // rest same var from SIP
  const stopsip_amctW = watch("stopsip_amc");
  const restartfundnameW = watch("restartfundname");

  useEffect(() => {
    // For auto set Lump Sum Amount according to Transaction Amount (Switch Amount) in Action Switch
    setValue("stplumpsumamount1", lumpSumAmountRedeemW);
  }, [lumpSumAmountRedeemW]);

  useEffect(() => {
    if (ActionW === "") {
      setActionName("");
      return;
    }

    // ------------------ Redeem Logic ------------------
    if (ActionW === "Redeem") {
      if (allUnitsRedeemW === "yes") {
        if (reInvestW === "yes" && goalNameRedeemW && lumpSumAmountRedeemW) {
          setActionName(
            <div style={{ textAlign: "center" }}>
              Redeem All Units and then Re-Invest Rs.{lumpSumAmountRedeemW}
              {fundNameRedeemW && (
                <>
                  {" into "}
                  {fundNameRedeemW}
                  <IoInformationCircleOutline
                    className="ms-2"
                    onClick={() => showFundDetails(fundNameRedeemW)}
                    style={{ cursor: "pointer" }}
                  />
                  {" for  "}
                  {goalNameRedeemW}
                </>
              )}
              {redeem_stpW === "yes" && STP_FrequencyW && (
                <>
                  {`. Start a ${STP_FrequencyW} STP`}
                  {stpDurationMonthW && (
                    <>
                      {STP_FrequencyW === "Monthly" && (
                        <span>
                          {` of ₹${(
                            stplumpsumamount1W / stpDurationMonthW
                          ).toFixed(0)} for ${stpDurationMonthW} months`}
                        </span>
                      )}

                      {STP_FrequencyW === "Weekly" && (
                        <span>
                          {` of ₹${(
                            stplumpsumamount1W /
                            (stpDurationMonthW * 4)
                          ).toFixed(0)} for ${stpDurationMonthW}  months`}
                        </span>
                      )}
                      {STP_fundNameW && (
                        <>
                          {" into "}
                          {STP_fundNameW}
                          <IoInformationCircleOutline
                            className="ms-2"
                            onClick={() => showFundDetails(STP_fundNameW)}
                            style={{ cursor: "pointer" }}
                          />
                        </>
                      )}
                    </>
                  )}
                </>
              )}
              {"."}
              {/*STP2*/}
              {redeem_stp1W === "yes" && STP_Frequency1W && (
                <>
                  {console.log("redeem_stp1W", redeem_stp1W, STP_Frequency1W)}
                  {`. Start a ${STP_Frequency1W} STP`}
                  {stpdurationmonth1W && (
                    <>
                      {STP_Frequency1W === "Monthly" && (
                        <span>
                          {` of ${formatRupees(
                            stplumpsumamount1W1 / stpdurationmonth1W
                          )} for ${stpdurationmonth1W} months`}
                        </span>
                      )}

                      {STP_Frequency1W === "Weekly" && (
                        <span>
                          {` of ${formatRupees(
                            stplumpsumamount1W1 / (stpdurationmonth1W * 4)
                          )} for ${stpdurationmonth1W}  months`}
                        </span>
                      )}
                      {STP_fundName1W && ` into ${STP_fundName1W} `}
                      <IoInformationCircleOutline
                        className="ms-2"
                        onClick={() => showFundDetails(STP_fundName1W)}
                        style={{ cursor: "pointer" }}
                      />
                    </>
                  )}
                </>
              )}
              {/*STP3*/}
              {redeem_stp2W === "yes" && STP_Frequency2W && (
                <>
                  {`. Start a ${STP_Frequency2W} STP`}
                  {stpdurationmonth2W && (
                    <>
                      {STP_Frequency2W === "Monthly" && (
                        <span>
                          {` of ${formatRupees(
                            stplumpsumamount1W2 / stpdurationmonth2W
                          )} for ${stpdurationmonth2W} months`}
                        </span>
                      )}

                      {STP_Frequency2W === "Weekly" && (
                        <span>
                          {` of ${formatRupees(
                            stplumpsumamount1W2 / (stpdurationmonth2W * 4)
                          )} for ${stpdurationmonth2W}  months`}
                        </span>
                      )}
                      {STP_fundName2W && ` into ${STP_fundName2W} `}
                      <IoInformationCircleOutline
                        className="ms-2"
                        onClick={() => showFundDetails(STP_fundName2W)}
                        style={{ cursor: "pointer" }}
                      />
                    </>
                  )}
                </>
              )}
            </div>
          );
          return;
        } else {
          setActionName("Redeem All Units.");
          return;
        }
      }

      if (allUnitsRedeemW === "no" && transactionAmountRedeemW) {
        setActionName(
          <div style={{ textAlign: "center" }}>
            Redeem Rs.{transactionAmountRedeemW}
            {reInvestW === "yes" && goalNameRedeemW && lumpSumAmountRedeemW && (
              <>
                {` and then Re-Invest Rs.${lumpSumAmountRedeemW}`}
                {fundNameRedeemW && (
                  <>
                    {" into "}
                    {fundNameRedeemW}
                    <IoInformationCircleOutline
                      className="ms-2"
                      onClick={() => showFundDetails(fundNameRedeemW)}
                      style={{ cursor: "pointer" }}
                    />
                    {" for "}
                    {goalNameRedeemW}
                  </>
                )}
                {redeem_stpW === "yes" && STP_FrequencyW && (
                  <>
                    {`. Start a ${STP_FrequencyW} STP`}
                    {stpDurationMonthW && (
                      <>
                        {STP_FrequencyW === "Monthly" && (
                          <span>
                            {` of ₹${(
                              stplumpsumamount1W / stpDurationMonthW
                            ).toFixed(0)} for ${stpDurationMonthW} months`}
                          </span>
                        )}

                        {STP_FrequencyW === "Weekly" && (
                          <span>
                            {` of ₹${(
                              stplumpsumamount1W /
                              (stpDurationMonthW * 4)
                            ).toFixed(0)} for ${stpDurationMonthW}  months`}
                          </span>
                        )}
                        {STP_fundNameW && ` into ${STP_fundNameW}`}
                      </>
                    )}
                  </>
                )}

                {/*STP2*/}
                {redeem_stp1W === "yes" && STP_Frequency1W && (
                  <>
                    {console.log("redeem_stp1W", redeem_stp1W, STP_Frequency1W)}
                    {`. Start a ${STP_Frequency1W} STP`}
                    {stpdurationmonth1W && (
                      <>
                        {STP_Frequency1W === "Monthly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W1 / stpdurationmonth1W
                            )} for ${stpdurationmonth1W} months`}
                          </span>
                        )}

                        {STP_Frequency1W === "Weekly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W1 / (stpdurationmonth1W * 4)
                            )} for ${stpdurationmonth1W}  months`}
                          </span>
                        )}
                        {STP_fundName1W && ` into ${STP_fundName1W} `}
                        <IoInformationCircleOutline
                          className="ms-2"
                          onClick={() => showFundDetails(STP_fundName1W)}
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                  </>
                )}
                {/*STP3*/}
                {redeem_stp2W === "yes" && STP_Frequency2W && (
                  <>
                    {`. Start a ${STP_Frequency2W} STP`}
                    {stpdurationmonth2W && (
                      <>
                        {STP_Frequency2W === "Monthly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W2 / stpdurationmonth2W
                            )} for ${stpdurationmonth2W} months`}
                          </span>
                        )}

                        {STP_Frequency2W === "Weekly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W2 / (stpdurationmonth2W * 4)
                            )} for ${stpdurationmonth2W}  months`}
                          </span>
                        )}
                        {STP_fundName2W && ` into ${STP_fundName2W} `}
                        <IoInformationCircleOutline
                          className="ms-2"
                          onClick={() => showFundDetails(STP_fundName2W)}
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                  </>
                )}
              </>
            )}
            {"."}
          </div>
        );
        return;
      }
    }

    // ------------------ Switch Logic ------------------
    if (ActionW === "Switch") {
      if (allUnitsSwitchW === "yes") {
        setActionName(
          <div style={{ textAlign: "center" }}>
            Switch All Units
            {switchInFundW && (
              <>
                {" into "}
                {switchInFundW}
                <IoInformationCircleOutline
                  className="ms-2"
                  onClick={() => showFundDetails(switchInFundW)}
                  style={{ cursor: "pointer" }}
                />

                {stpSwitchW === "yes" && stpSwitchFrequencyW && (
                  <>
                    {`. Start a ${stpSwitchFrequencyW} STP`}
                    {stpSwitchDurationW && (
                      <>
                        {stpSwitchFrequencyW === "Monthly" && (
                          <span>
                            {` of ${formatRupees(
                              stpSwitchlumpSumAmountW / stpSwitchDurationW
                            )} for ${stpSwitchDurationW} months`}
                          </span>
                        )}

                        {stpSwitchFrequencyW === "Weekly" && (
                          <span>
                            {` of ${formatRupees(
                              stpSwitchlumpSumAmountW / (stpSwitchDurationW * 4)
                            )} for ${stpSwitchDurationW}  months`}
                          </span>
                        )}
                        {STP_fundNameW && ` into ${STP_fundNameW} `}
                        <IoInformationCircleOutline
                          className="ms-2"
                          onClick={() => showFundDetails(stpSwitchfundNameW)}
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                  </>
                )}

                {/*STP2*/}
                {redeem_stp1W === "yes" && STP_Frequency1W && (
                  <>
                    {console.log("redeem_stp1W", redeem_stp1W, STP_Frequency1W)}
                    {`. Start a ${STP_Frequency1W} STP`}
                    {stpdurationmonth1W && (
                      <>
                        {STP_Frequency1W === "Monthly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W1 / stpdurationmonth1W
                            )} for ${stpdurationmonth1W} months`}
                          </span>
                        )}

                        {STP_Frequency1W === "Weekly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W1 / (stpdurationmonth1W * 4)
                            )} for ${stpdurationmonth1W}  months`}
                          </span>
                        )}
                        {STP_fundName1W && ` into ${STP_fundName1W} `}
                        <IoInformationCircleOutline
                          className="ms-2"
                          onClick={() => showFundDetails(STP_fundName1W)}
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                  </>
                )}
                {/*STP3*/}
                {redeem_stp2W === "yes" && STP_Frequency2W && (
                  <>
                    {`. Start a ${STP_Frequency2W} STP`}
                    {stpdurationmonth2W && (
                      <>
                        {STP_Frequency2W === "Monthly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W2 / stpdurationmonth2W
                            )} for ${stpdurationmonth2W} months`}
                          </span>
                        )}

                        {STP_Frequency2W === "Weekly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W2 / (stpdurationmonth2W * 4)
                            )} for ${stpdurationmonth2W}  months`}
                          </span>
                        )}
                        {STP_fundName2W && ` into ${STP_fundName2W} `}
                        <IoInformationCircleOutline
                          className="ms-2"
                          onClick={() => showFundDetails(STP_fundName2W)}
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                  </>
                )}
              </>
            )}
            {"."}
          </div>
        );
        return;
      }

      if (allUnitsSwitchW === "no" && transactionAmountSwitchW) {
        setActionName(
          <div style={{ textAlign: "center" }}>
            Switch Rs. {transactionAmountSwitchW}
            {switchInFundW && (
              <>
                {" into "}
                {switchInFundW}
                <IoInformationCircleOutline
                  className="ms-2"
                  onClick={() => showFundDetails(switchInFundW)}
                  style={{ cursor: "pointer" }}
                />

                {stpSwitchW === "yes" && stpSwitchFrequencyW && (
                  <>
                    {`. Start a ${stpSwitchFrequencyW} STP`}

                    {stpSwitchDurationW && (
                      <>
                        {stpSwitchFrequencyW === "Monthly" && (
                          <span>
                            {` of ${formatRupees(
                              stpSwitchlumpSumAmountW / stpSwitchDurationW
                            )} for ${stpSwitchDurationW} months`}
                          </span>
                        )}

                        {stpSwitchFrequencyW === "Weekly" && (
                          <span>
                            {` of ${formatRupees(
                              stpSwitchlumpSumAmountW / (stpSwitchDurationW * 4)
                            )} for ${stpSwitchDurationW}  months`}
                          </span>
                        )}
                        {STP_fundNameW && ` into ${STP_fundNameW} `}
                        <IoInformationCircleOutline
                          className="ms-2"
                          onClick={() => showFundDetails(stpSwitchfundNameW)}
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                  </>
                )}

                {/*STP2*/}
                {redeem_stp1W === "yes" && STP_Frequency1W && (
                  <>
                    {console.log("redeem_stp1W", redeem_stp1W, STP_Frequency1W)}
                    {`. Start a ${STP_Frequency1W} STP`}
                    {stpdurationmonth1W && (
                      <>
                        {STP_Frequency1W === "Monthly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W1 / stpdurationmonth1W
                            )} for ${stpdurationmonth1W} months`}
                          </span>
                        )}

                        {STP_Frequency1W === "Weekly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W1 / (stpdurationmonth1W * 4)
                            )} for ${stpdurationmonth1W}  months`}
                          </span>
                        )}
                        {STP_fundName1W && ` into ${STP_fundName1W} `}
                        <IoInformationCircleOutline
                          className="ms-2"
                          onClick={() => showFundDetails(STP_fundName1W)}
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                  </>
                )}
                {/*STP3*/}
                {redeem_stp2W === "yes" && STP_Frequency2W && (
                  <>
                    {`. Start a ${STP_Frequency2W} STP`}
                    {stpdurationmonth2W && (
                      <>
                        {STP_Frequency2W === "Monthly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W2 / stpdurationmonth2W
                            )} for ${stpdurationmonth2W} months`}
                          </span>
                        )}

                        {STP_Frequency2W === "Weekly" && (
                          <span>
                            {` of ${formatRupees(
                              stplumpsumamount1W2 / (stpdurationmonth2W * 4)
                            )} for ${stpdurationmonth2W}  months`}
                          </span>
                        )}
                        {STP_fundName2W && ` into ${STP_fundName2W} `}
                        <IoInformationCircleOutline
                          className="ms-2"
                          onClick={() => showFundDetails(STP_fundName2W)}
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                  </>
                )}
              </>
            )}
            {"."}
          </div>
        );
        return;
      }
    }

    // ------------------ STP Logic ------------------
    if (ActionW === "STP" && frequencySTPW) {
      setActionName(
        <div style={{ textAlign: "center" }}>
          {`Start a ${frequencySTPW} STP`}
          {/* {durationSTPW && ` for ${durationSTPW} months`} */}
          {durationSTPW && (
              <>
                {frequencySTPW === "Monthly" && (
                  <span>
                    {` of ${formatRupees(
                      lumpSumAmountSTPW / durationSTPW
                    )} for ${durationSTPW} months`}
                  </span>
                )}

                {stpSwitchFrequencyW === "Weekly" && (
                  <span>
                    {` of ${formatRupees(
                      lumpSumAmountSTPW / (durationSTPW * 4)
                    )} for ${durationSTPW}  months`}
                  </span>
                )}
                {STP_fundNameW && ` into ${STP_fundNameW} `}
                <IoInformationCircleOutline
                  className="ms-2"
                  onClick={() => showFundDetails(stpSwitchfundNameW)}
                  style={{ cursor: "pointer" }}
                />
              </>
            )}
          {/* {lumpSumAmountSTPW && ` of Rs. ${lumpSumAmountSTPW}`} */}
          {stpInFundW && (
            <>
              {" into "}
              {stpInFundW}
              <IoInformationCircleOutline
                className="ms-2"
                onClick={() => showFundDetails(stpInFundW)}
                style={{ cursor: "pointer" }}
              />
            </>
          )}
          {"."}
        </div>
      );
      return;
    }

    // ------------------ SIP Logic ------------------
    if (ActionW === "SIP" && goalNameSIPW && sipAmountSIPW) {
      setActionName(
        `Start a Monthly SIP of Rs. ${sipAmountSIPW} for ${goalNameSIPW}.`
      );
      return;
    }
    // ------------------ SIP Stp Logic ------------------
    // const activesips = activeSips.reduce((acc, sip) => {
    //   if (stopSipSelection[sip._id]) {
    //     acc[sip._id] = sip.sip_amount;
    //   }
    //   return acc;
    // }, {});
    const amounts = Object.values( {});
    const totalAmount = amounts.reduce((sum, amt) => sum + amt, 0);
    console.log('amounts',amounts,startasipW);

    if (ActionW === "sip_stop") {
      setActionName(
        <div>
          {`Stop the existing SIP  `}

          {amounts.length > 0 && (
            <>
              {/* {amounts.map((amt, i) => (
                <div key={i}>of Rs. {amt}</div>
              ))} */}
               <span>{`of ₹${amounts[0]}`}</span>
            </>
          )}
          {startasipW === "yes" && (
                <span> and Restart a Monthly SIP {' '}

                  {sipAmountSIPW && `of Rs. ${sipAmountSIPW} for ${goalNameSIPW}`}
                   </span>
          )}

            {fundNameRedeemW && (
                <>
                  {" into "}
                  {fundNameRedeemW}
                  <IoInformationCircleOutline
                    className="ms-2"
                    onClick={() => showFundDetails(fundNameRedeemW)}
                    style={{ cursor: "pointer" }}
                  />
                </>
              )}
        </div>
      );
      return;
    }

    // Fallback
    setActionName("");
  }, [
    restartfundnameW,
    stopsip_amctW,
    startasipW,
    redeem_stp2W,
    STP_Frequency2W,
    stpdurationmonth2W,
    stplumpsumamount1W2,
    STP_fundName2W,
    redeem_stp1W,
    STP_Frequency1W,
    stpdurationmonth1W,
    stplumpsumamount1W1,
    STP_fundName1W,
    ActionW,
    allUnitsRedeemW,
    transactionAmountRedeemW,
    reInvestW,
    goalNameRedeemW,
    lumpSumAmountRedeemW,
    fundNameRedeemW,
    redeem_stpW,
    STP_FrequencyW,
    stpDurationMonthW,
    STP_fundNameW,
    allUnitsSwitchW,
    transactionAmountSwitchW,
    switchInFundW,
    stpSwitchW,
    stpSwitchFrequencyW,
    stpSwitchDurationW,
    stpSwitchlumpSumAmountW,
    stpSwitchfundNameW,
    frequencySTPW,
    durationSTPW,
    lumpSumAmountSTPW,
    stpInFundW,
    goalNameSIPW,
    sipAmountSIPW,
    // openSipFormAllData,
  ]);

  const showFundDetails = async (fundName, goalName) => {};

  const getAMCFundName = async (fundName) => {
    try {
      const response = await api.get(
        `advisor/amc_fund_by_house?house_name=${fundName}`
      );
      setAmcNameList(response.data);
    } catch (error) {
      console.error("Error fetching AMC fund names:", error);
    }
  };

  // When the investmentType changes, get AMC Fund Name
  useEffect(() => {
    if (selectedAmcHouse ||stopsip_amctW) {
      getAMCFundName(selectedAmcHouse ||stopsip_amctW);
    }
  }, [selectedAmcHouse,stopsip_amctW]);

  function parsePortfolioOptions(optionsString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(optionsString, "text/html");
    const options = doc.querySelectorAll("option");

    let result = [];

    options.forEach((option) => {
      const valueParts = option.value.split("|");
      result.push({
        name: option.textContent.trim(),
        id: option.getAttribute("data-id"),
        targetYear: option.getAttribute("data-targetyear") || null,
        expectedReturn: option.getAttribute("data-Expectedreturn") || null,
        aum: option.getAttribute("data-aum") || null,
        runningSIP: option.getAttribute("data-runningSIP") || null,
        targetAmount: option.getAttribute("data-targetAmount") || null,
        requiredSIP: option.getAttribute("data-requiredSIP") || null,
      });
    });

    return result;
  }

  const handleRedeemStartDateChange1 = (date) => {
    setStpRedeemstartDate_1(date);
  };
  const handleRedeemStartDateChange2 = (date) => {
    setStpRedeemstartDate_2(date);
  };

  useEffect(() => {
    if (ActionW === "SIP" || ActionW === "sip_stop") {
      if (preGoalName === "" || preGoalName === "Unmapped"||preGoalName === undefined) {
        Swal.fire({
          text: "Cannot start SIP in this folio as it isn't mapped to a goal",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn",
          },
        });
        onHide(true);
        setSipAction("");
      } else {
        setValue("goalNameSIP", preGoalName);
      }
    }
  }, [ActionW, preGoalName]);

  const [preData, setPreData] = useState();


 

  const is = (a, action) => action === a;
       const str = (v) => (v ?? "");
       const num = (v) => (v === "" || v == null ? "" : Number(v));
 
       function makePayload(action, data, generateEiFormData = {}, extra = {}) {
         const {
           activesips = {},
           stp, stpfundName, duration, frequency,
           lumpSumAmount, startDate,
           stpRedeemstartDate1, stpRedeemstartDate2,
           invStartYear, invGoalYear, preGoalName,
         } = extra;
 
         const reinvestNo = data?.reInvest === "no";
 
         // ---- Base (common) ----
         const payload = {
           sipaction: str(action),
           pr_row_id:str(preData?.pr_row_id),
           schemename: str(generateEiFormData.schemename),
           portfolioid: str(generateEiFormData.portfolioid),
           currentval: str(generateEiFormData.currentval),
           clientid: str(generateEiFormData.clientid),
           ISIN: str(generateEiFormData.ISIN),
           isSIP: data?.sipaction === "Switch" ? 0 : (generateEiFormData.isSIP ?? 0),
           moneyformatecurval: str(generateEiFormData.moneyformatecurval),
 
           fundname: str(generateEiFormData.fundname),
           startYear: str(invStartYear),
           goalYear: str(invGoalYear || generateEiFormData.goalYear),
           goalNamePre: str(generateEiFormData.goalName),
           goalIdPre: str(generateEiFormData.goalId),
 
           isreviewed: 1,
           act: "submit",
           test: "test4",
         };
 
         // ---- SIP STOP ----
          Object.assign(payload,
            is("sip_stop", action) && {
              startasip: str(data.startasip),
              stoptsip: "yes",
              restartfundname: str(data.restartfundname),
              siprestartamount: num(data.sipAmountSIP),
              stopsip_amc: str(data.stopsip_amc),
              siprestartdate: str(data.sipStartDate),
              siprePerpetual: str(data?.perpetualSIP),
              stopsip_enddate: str(data.sipEndDate),
              activesips,
            }
          );
 
         // ---- Redeem ----
         Object.assign(payload,
           is("Redeem", action) && {
             allunites: str(data?.allUnitsRedeem),
             no_ofunites: data?.allUnitsRedeem === "no"
               ? num(data?.transactionAmountRedeem)
               : str(generateEiFormData?.currentval),
             reinvest: str(data.reInvest),
 
             // cash-out ho to goal/fund blank
             goalName: reinvestNo ? "" : str(data?.goalNameRedeem || preGoalName),
             limpsuamt: reinvestNo ? "" : num(data.lumpSumAmountRedeem),
             selectfundhouse: reinvestNo ? "" : str(data?.amcHouseRedeem),
             selectfund: reinvestNo ? "" : str(data?.fundNameRedeem),
 
             // STP only if reinvest !== "no"
             ...(reinvestNo ? {} : {
               redeem_stp: str(stp),
               STP_fundName: str(stpfundName),
               stpdurationmonth: str(duration),
               STP_Frequency: str(frequency),
               stplumpsumamount: num(lumpSumAmount),
               stpstartdate: str(startDate),
 
               redeem_stp1: str(data.redeem_stp1 || "no"),
               STP_fundName1: str(data.STP_fundName1),
               stpdurationmonth1: str(data.stpdurationmonth1),
               STP_Frequency1: str(data.STP_Frequency1),
               stplumpsumamount1: num(data.stplumpsumamount11),
               stpstartdate1: str(stpRedeemstartDate1),
 
               redeem_stp2: str(data.redeem_stp2 || "no"),
               STP_fundName2: str(data.STP_fundName2),
               stpdurationmonth2: str(data.stpdurationmonth2),
               STP_Frequency2: str(data.STP_Frequency2),
               stplumpsumamount2: num(data.stplumpsumamount12),
               stpstartdate2: str(stpRedeemstartDate2),
             }),
           }
         );
 
         // ---- Switch ----
          Object.assign(payload,
            is("Switch", action) && {
              alluniteswitch: str(data.allUnitsSwitch),

              // agar partial switch ("no") hai → user amount lo
              // agar full switch hai → current value lo
              no_ofunites_switch:
                data?.allUnitsSwitch === "no"
                  ? num(data?.transactionAmountSwitch)
                  : str(generateEiFormData?.currentval),

              switchfund: str(data.switchInFund),

              swp_frequency: "",
              swp_amount: "",
              swp_startdate: "",
              swp_tenor: "",

              redeem_stp: str(stp), //  yeh hamesha jayega (user ke choice ke hisaab se "yes"/"no")
            },

            //  STP fields sirf tab jab redeem_stp === "yes"
            is("Switch", action) && str(stp) === "yes" && {
              STP_fundName: str(stpfundName),
              stpdurationmonth: str(duration),
              STP_Frequency: str(frequency),
              stplumpsumamount: num(lumpSumAmount),
              stpstartdate: str(startDate),

              redeem_stp1: str(data.redeem_stp1 || "no"),
              STP_fundName1: str(data.STP_fundName1),
              stpdurationmonth1: str(data.stpdurationmonth1),
              STP_Frequency1: str(data.STP_Frequency1),
              stplumpsumamount1: num(data.stplumpsumamount11),
              stpstartdate1: str(stpRedeemstartDate1),

              redeem_stp2: str(data.redeem_stp2 || "no"),
              STP_fundName2: str(data.STP_fundName2),
              stpdurationmonth2: str(data.stpdurationmonth2),
              STP_Frequency2: str(data.STP_Frequency2),
              stplumpsumamount2: num(data.stplumpsumamount12),
              stpstartdate2: str(stpRedeemstartDate2),
            }
          );
           
          
          // ---- STP----
          Object.assign(payload,
            is("STP", action) && {
              redeem_stp: str(stp),
              STP_Frequency: str(frequency),
              stpdurationmonth: str(duration),
              stplumpsumamount: num(lumpSumAmount),
              STP_fundName: str(stpfundName),
              stpstartdate: str(startDate),
            }
          );
         // ---- SIP (new) ----
         Object.assign(payload,
           is("SIP", action) && {
            siptypeaction: str(data?.sipaction),
            sipfundname: str(generateEiFormData.fundname),
            goalName: preGoalName,
            goalNameStart: str(generateEiFormData.goalName),
            sipfrequency: "Monthly",
            stoptsip:'no',
            sipstartdate: str(data.sipStartDate),
            sipamount: num(data.sipAmountSIP),
            sipPerpetual: str(data?.perpetualSIP),
            sipenddate: str(data.sipEndDate),
            test: "SIP",
           }
         );
 
         return payload;
       }
  
  const onSubmit = async (data) => {
    console.log("tt", generateEiFormData, isGoalResponse);
    
    let action = data?.sipaction;
    let invGoalName = preGoalName || "";
    let invGoalId = preGoalId || "";
    let invFundname = preGoalDetails?.fundname;
    let invrunningSIP = preGoalDetails?.runningSIP || "";
    let invCagr = preGoalDetails?.expectedReturn || "";
    let invGoalYear = preGoalDetails?.goalYear || "";
    let invStartYear = preGoalDetails?.startyear || "";
    let invTargetAmount = Number(preGoalDetails?.TargetAmount) || "";
    let invaum = Number(preGoalDetails?.accumulatedAmount) || "";
   
    // let invFundname = generateEiFormData?.fundname
    // let invrunningSIP = generateEiFormData?.runningSIP || "";
    // let invCagr = generateEiFormData?.expectedReturn || "";
    // let invGoalYear = generateEiFormData?.goalYear || "";
    // let invStartYear = generateEiFormData?.startyear || "";
    // let invTargetAmount = Number(generateEiFormData?.TargetAmount) || "";
    // let invaum = Number(generateEiFormData?.accumulatedAmount) || "";

    
    let newSIP = parseInt(data.sipAmountSIP);



    
    let no_ofunites = 0;
    let remainingMonth = (invGoalYear - invStartYear) * 12;

    if (action == "SIP") {
      let oneTimeInvFutureVal =
        invaum * Math.pow(1 + invCagr / 100, invGoalYear - invStartYear);
      let capitalGrowth = 0;
      let monthEndValue = 0,
        finalCorpus = 0;
      let totalSIP = invrunningSIP + newSIP;

      monthEndValue = monthEndValue + totalSIP;
      finalCorpus = Math.round(monthEndValue) + Math.round(oneTimeInvFutureVal);

     

      console.log('invGoalYear',generateEiFormData?.TargetAmount,invTargetAmount);

      if (finalCorpus < invTargetAmount) {
        // const allData = {
        //   stoptsip: "yes",
        //   startasip: "yes",
        //   sipaction: action || "",
        //   allunites: data?.allUnitsRedeem || "",
        //   no_ofunites:data?.allUnitsRedeem==='no'? data?.transactionAmountRedeem || "":isGoalResponse?.currentval,
        //   reinvest: "",
        //   goalName: invGoalName || "",
        //   limpsuamt: "",
        //   selectfundhouse: data.amcHouseRedeem || "",
        //   selectfund: data.fundNameRedeem || "",
        //   lumpsuamtount: "",
        //   selectfundlumpsum: "",

        //   alluniteswitch: data.allUnitsSwitch || "",
        //   no_ofunites_switch: "",
        //   switchfund: data.switchInFund || "",
        //   swp_frequency: "",
        //   swp_amount: "",
        //   swp_startdate: "",
        //   swp_tenor: "",
        //   redeem_stp: data.stp || "",
        //   STP_Frequency: data.frequencySTP || data.stpSwitchFrequency || "",
        //   stplumpsumamount: "",
        //   stpdurationmonth:
        //     data.durationSTP || data.stpDurationMonthRedeem || "",
        //   STP_fundName: "",

        //   sipfundname: "",
        //   goalNameStart: isGoalResponse?.goalName || "",
        //   siprestartdate: data.sipStartDate || "",
        //   siprestartamount: data.sipAmountSIP || "",
        //   siprePerpetual: data?.perpetualSIP || "",
        //   sipfrequency: "Monthly",
        //   stopsip_enddate: data.sipEndDate || "",

        //   // selectedStartDate ||
        //   stpstartdate: "",
        //   isreviewed: 1,

        //   siptypeaction: data?.sipaction || "",
        //   schemename: isGoalResponse?.schemename || "",
        //   portfolioid: isGoalResponse?.portfolioid || "",
        //   currentval: isGoalResponse?.currentval || "",
        //   clientid: isGoalResponse?.clientid || "",
        //   ISIN: isGoalResponse?.ISIN || "",
        //   isSIP: isGoalResponse?.isSIP || "",
        //   moneyformatecurval: isGoalResponse?.moneyformatecurval || "",

        //   fundname: isGoalResponse?.fundname || "",

        //   startYear: invStartYear || "",
        //   goalYear: invGoalYear || "",
        //   goalNamePre: isGoalResponse?.goalName || "",
        //   goalIdPre: isGoalResponse?.goalId || "",
        //   act: "submit",
        // };

        let stp = "yes";
        let frequency = data.frequencySTP;
        let duration = data.durationSTP;
        let lumpSumAmount = data.lumpSumAmountSTP;
        let stpfundName = data.stpInFund;
        let startDate = data.stpStartDate;

        const allData = makePayload(action, data, generateEiFormData, {
          stp, stpfundName, duration, frequency,
          lumpSumAmount, startDate,
          stpRedeemstartDate1, stpRedeemstartDate2,
          invStartYear, invGoalYear, preGoalName,
        });
        console.log('allData',allData);


        try {
          const response = await api.post(
            `advisor/saveExternalportfolio`,
            allData
          );
          console.log("saveExternalportfolio", response.data);
          if (
            response.data.status === false &&
            response.data.errors &&
            Object.keys(response.data.errors).length > 0
          ) {
            console.log("saveExternalportfolio", response.data);

            if (response.data.errors.no_ofunites) {
              setError("transactionAmountRedeem", {
                type: "manual",
                message: response.data.errors.no_ofunites,
              });
            } else {
              clearErrors("transactionAmountRedeem");
            }
            // Add more fields as needed
          } else if (response.data.message !== "") {
            onHide(true);
            Swal.fire({
              title: "Success",
              icon: "success",
              html: response.data.message,
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "swal-confirm-btn",
              },
            }).then(() => {
              // setIsActionMessage(response.data.message);

              // Inside FundEditModal, after API success
              // onActionUpdate(
              //   rowKey,
              //   response.data.message,
              //   response.data.scheme_code
              // );
              // onActionSchemeCode(rowKey, response.data.scheme_code);
              socket.emit("join", { room: roomId });
              socket.emit("message_to",
                {
                  room: roomId,
                  data: {
                    message: response?.data?.message || "Client data updated successfully",
                    type: "success",
                  }

                })

              fetchGetEiFolioData();
              resetModalStates();
            });
          }
        } catch (error) {
          console.error("Error fetching generatesipform data:", error.data);
        }
      } else {
        var diff = finalCorpus - invTargetAmount;
        Swal.fire({
          title: "Oops! Exceeds Goal Target!",
          text: `This investment will bring the projected achievement to ${finalCorpus}, which is ${diff} higher than the Goal Target of ${invTargetAmount}.`,
          icon: "error",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn",
          },
        });
      }
    } else if (data.reinvest === "yes") {
      let aum;
      remainingMonth = (invGoalYear - invStartYear) * 12;

      var reinvest = data.reinvest;
      if (reinvest == "yes" && invGoalName === "") {
        Swal.fire({
          text: "Please Select a Goal to Invest",
          icon: "error",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn",
          },
        });
        return false;
      } else {
        let newSIP = 0;
        if (isGoalResponse?.goalId == invGoalId) {
          if (data.allUnitsRedeem === "yes") {
            aum = Math.round(data.lumpSumAmountRedeem);
          } else {
            invaum =
              invaum - no_ofunites + Math.round(data.lumpSumAmountRedeem);
          }
          let oneTimeInvFutureVal =
            invaum * Math.pow(1 + invCagr / 100, invGoalYear - invStartYear);
          let capitalGrowth = 0;
          let monthEndValue = 0,
            finalCorpus = 0;
          let totalSIP = invrunningSIP + newSIP;
          for (var i = 1; i < remainingMonth; i++) {
            capitalGrowth = ((monthEndValue + totalSIP) * invCagr) / 1200;
            monthEndValue = monthEndValue + capitalGrowth + totalSIP;
          }
          monthEndValue = monthEndValue + totalSIP;
          finalCorpus =
            Math.round(monthEndValue) + Math.round(oneTimeInvFutureVal);
          if (finalCorpus < invTargetAmount) {
            // ok;
            // $('#startYear').val(startYear);
            // $('#goalYear').val(goalYear);
            const allData = {
              sipaction: action,
              allunites: data?.allUnitsRedeem,
              no_ofunites: 0,
              reinvest: data.reInvest,
              goalName: invGoalName,
              limpsuamt: data.lumpSumAmountRedeem || "",
              selectfundhouse: data.amcHouseRedeem,
              selectfund: data.fundNameRedeem,
              lumpsuamtount: "",
              selectfundlumpsum: "",

              alluniteswitch: data.allUnitsSwitch,
              no_ofunites_switch: "",
              switchfund: data.switchInFund,
              swp_frequency: "",
              swp_amount: "",
              swp_startdate: "",
              swp_tenor: "",
              redeem_stp: data.stp,
              STP_Frequency: data.frequencySTP || data.stpSwitchFrequency,
              stplumpsumamount: "",
              stpdurationmonth: data.durationSTP || data.stpDurationMonthRedeem,
              STP_fundName: data.switchInFund || "",

              sipfundname: "",
              goalNameStart: isGoalResponse?.goalName,
              // selectedStartDate ||
              sipstartdate: "",
              sipamount: data.sipAmountSIP,
              sipfrequency: "Monthly",
              sipPerpetual: "",
              sipenddate: "",

              // selectedStartDate ||
              stpstartdate: "",
              isreviewed: 1,

              siptypeaction: data?.sipaction,
              schemename: isGoalResponse?.schemename,
              portfolioid: isGoalResponse?.portfolioid,
              currentval: isGoalResponse?.currentval,
              clientid: isGoalResponse?.clientid,
              ISIN: isGoalResponse?.ISIN,
              isSIP: isGoalResponse?.isSIP,
              moneyformatecurval: isGoalResponse?.moneyformatecurval,

              fundname: isGoalResponse?.fundname,
              startYear: invStartYear,
              goalYear: invGoalYear,
              goalNamePre: isGoalResponse?.goalName,
              goalIdPre: isGoalResponse?.goalId,
              act: "submit",
              test: "test",
            };

            try {
              const response = await api.post(
                `advisor/saveExternalportfolio`,
                allData
              );
              console.log("saveExternalportfolio", response.data);
              if (response.data.message !== "") {
                Swal.fire({
                  title: "Success",
                  text: response.data.message,
                  icon: "success",
                  confirmButtonText: "OK",
                  customClass: {
                    confirmButton: "swal-confirm-btn",
                  },
                }).then(() => {
             
                    socket.emit("join", { room: roomId });
                    socket.emit("message_to",
                      {
                        room: roomId,
                        data: {
                          message: response?.data?.message || "Client data updated successfully",
                          type: "success",
                        }

                      })

                    fetchGetEiFolioData();
                    resetModalStates();
                  })
              }
            

              // const obj = (response.data);
              //     $('#suscessmsg').removeAttr("style");
              //     $('#suscessmsg').html(obj.message);
              //     if(obj.message=='')
              //     {
              //       $('#suscessmsg').hide();
              //     }
              //     else
              //     {
              //       $('#suscessmsg').hide();
              //     }
              //     if($.isEmptyObject(obj.errors)==true)
              //     {
              //       portfolioidid = $('#portfolioid').val();
              //       ISIN = $('#ISIN').val();
              //       portfolioidid = portfolioidid.replace("/","_");
              //       actremrkhtml = '#remarkact_'+portfolioidid+ISIN;
              //       var rowhtml = '#foliorow_'+portfolioidid+ISIN;
              //       $(rowhtml).removeClass('w3-pale-red');
              //       $(rowhtml).addClass('w3-pale-green');
              //       setTimeout(function()
              //       {
              //         $(rowhtml).removeClass('w3-pale-green');
              //       }, 15000);
              //       //$(actremrkhtml).html(obj.message);
              //       var msgstring = removeTags(obj.message);
              //       $(actremrkhtml).html(msgstring);
              //       $('#exampleModal').modal('hide');
            } catch (error) {
              console.error("Error fetching generatesipform data:", error.data);
            }
          } else {
            var diff = finalCorpus - invTargetAmount;

            Swal.fire({
              title: "Oops! Cannot exceed Goal Target",
              text:
                "This investment will take the projected achievement to " +
                finalCorpus +
                ", which is " +
                diff +
                " higher than the Goal Target of " +
                invTargetAmount +
                ".",
              icon: "error",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "swal-confirm-btn",
              },
            });
            return false;
          }
        } else {
          let aum = Math.round(data.lumpSumAmountRedeem);
          let invrunningSIP = invrunningSIP || 0;
          let targetAmountt = 0;

          if (
            typeof invTargetAmount !== "undefined" &&
            invTargetAmount !== ""
          ) {
            targetAmountt =
              parseInt(invTargetAmount.replace(/\D/g, ""), 10) || 0;
          }

          const remainingMonth = (invGoalYear - invStartYear) * 12;

          let oneTimeInvFutureVal =
            aum * Math.pow(1 + invCagr / 100, invGoalYear - invStartYear);

          let capitalGrowth = 0;
          let monthEndValue = 0;
          let finalCorpus = 0;

          const totalSIP = (invrunningSIP || 0) + (newSIP || 0);

          // Loop to calculate monthly growth
          for (let i = 1; i <= remainingMonth; i++) {
            capitalGrowth = (monthEndValue + totalSIP) * (invCagr / 1200);
            monthEndValue += capitalGrowth + totalSIP;
          }

          monthEndValue += totalSIP;

          // Final corpus calculation
          finalCorpus =
            Math.round(monthEndValue) + Math.round(oneTimeInvFutureVal);

          // Compare final corpus with the target amount
          if (finalCorpus < targetAmountt) {
            // $('#startYear').val(startYear);
            //     $('#goalYear').val(goalYear);

            const allData = {
              sipaction: action || "",
              allunites: data?.allUnitsRedeem || "",
              no_ofunites: 0 || "",
              reinvest: data.reInvest || "",
              goalName: invGoalName || "",
              limpsuamt: data.lumpSumAmountRedeem || "",
              selectfundhouse: data.amcHouseRedeem || "",
              selectfund: data.fundNameRedeem || "",
              lumpsuamtount: "",
              selectfundlumpsum: "",

              alluniteswitch: data.allUnitsSwitch || "",
              no_ofunites_switch: "",
              switchfund: data.switchInFund || "",
              swp_frequency: "",
              swp_amount: "",
              swp_startdate: "",
              swp_tenor: "",
              redeem_stp: data.stp || "",
              STP_Frequency: data.frequencySTP || data.stpSwitchFrequency || "",
              stplumpsumamount: "",
              stpdurationmonth:
                data.durationSTP || data.stpDurationMonthRedeem || "",
              STP_fundName: data.stpInFund || data.switchInFund || "",

              sipfundname: "",
              goalNameStart: isGoalResponse?.goalName || "",
              // selectedStartDate ||
              sipstartdate: "",
              sipamount: data.sipAmountSIP || "",
              sipfrequency: "Monthly",
              sipPerpetual: "",
              sipenddate: "",

              // selectedStartDate ||
              stpstartdate: "",
              isreviewed: 1,

              siptypeaction: data?.sipaction || "",
              schemename: isGoalResponse?.schemename || "",
              portfolioid: isGoalResponse?.portfolioid || "",
              currentval: isGoalResponse?.currentval || "",
              clientid: isGoalResponse?.clientid || "",
              ISIN: isGoalResponse?.ISIN || "",
              isSIP: isGoalResponse?.isSIP || "",
              moneyformatecurval: isGoalResponse?.moneyformatecurval || "",

              fundname: isGoalResponse?.fundname || "",
              startYear: invStartYear || "",
              goalYear: invGoalYear || "",
              goalNamePre: isGoalResponse?.goalName || "",
              goalIdPre: isGoalResponse?.goalId || "",
              act: "submit",
              test: "test2",
            };
            try {
              const response = await api.post(
                `advisor/saveExternalportfolio`,
                allData
              );
              console.log("saveExternalportfolio", response.data);
              if (response.data.message !== "") {
                Swal.fire({
                  title: "Success",
                  text: response.data.message,
                  icon: "success",
                  confirmButtonText: "OK",
                  customClass: {
                    confirmButton: "swal-confirm-btn",
                  },
                });
              }

              onHide();
              reset();
              setSipAction("");
              fetchGetEiFolioData();
       
              socket.emit("join", { room: roomId });
              socket.emit("message_to",
                {
                  room: roomId,
                  data: {
                    message: response?.data?.message || "Client data updated successfully",
                    type: "success",
                  }

                })

              resetModalStates();
              // setIsPerpetualSIP("");
              // success: function (response)
              // {
              //   const obj = JSON.parse(response);
              //   $('#suscessmsg').removeAttr("style");
              //   $('#suscessmsg').html(obj.message);
              //   if(obj.message=='')
              //   {
              //     $('#suscessmsg').hide();
              //   }
              //   else
              //   {
              //     $('#suscessmsg').hide();
              //   }
              //   if($.isEmptyObject(obj.errors)==true)
              //   {
              //     portfolioidid = $('#portfolioid').val();
              //     ISIN = $('#ISIN').val();
              //     portfolioidid = portfolioidid.replace("/","_");
              //     actremrkhtml = '#remarkact_'+portfolioidid+ISIN;
              //     var rowhtml = '#foliorow_'+portfolioidid+ISIN;
              //     $(rowhtml).removeClass('w3-pale-red');
              //     $(rowhtml).addClass('w3-pale-green');
              //     setTimeout(function()
              //     {
              //       $(rowhtml).removeClass('w3-pale-green');
              //     }, 15000);
              //     //$(actremrkhtml).html(obj.message);
              //     var msgstring = removeTags(obj.message);
              //     $(actremrkhtml).html(msgstring);
              //     $('#exampleModal').modal('hide');
              //   }
              // }
            } catch (error) {
              var diff = finalCorpus - invTargetAmount;
              Swal.fire({
                title: "Oops! Cannot exceed Goal Target",
                text:
                  "This investment will take the projected achievement to " +
                  finalCorpus +
                  ", which is " +
                  diff +
                  " higher than the Goal Target of " +
                  invTargetAmount +
                  ".",
                icon: "error",
                confirmButtonText: "OK",
                customClass: {
                  confirmButton: "swal-confirm-btn",
                },
              });
            }
          } else {
            var diff = finalCorpus - invTargetAmount;
            Swal.fire({
              title: "Oops! Cannot exceed Goal Target",
              text:
                "This investment will take the projected achievement to " +
                finalCorpus +
                ", which is " +
                diff +
                " higher than the Goal Target of " +
                invTargetAmount +
                ".",
              icon: "error",
            });
          }
        }
        return;
      }
    } else {
      if (invGoalYear != "") {
      }

      let stp;
      let frequency;
      let duration;
      let lumpSumAmount;
      let stpfundName;
      let startDate;
      if (data?.sipaction === "STP") {
        stp = "yes";
        frequency = data.frequencySTP;
        duration = data.durationSTP;
        lumpSumAmount = data.lumpSumAmountSTP;
        stpfundName = data.stpInFund;
        startDate = data.stpStartDate;
      } else if (data?.sipaction === "Redeem") {
        stp = data.redeem_stp;
        frequency = data.STP_Frequency;
        duration = data.stpDurationMonthRedeem;
        lumpSumAmount = data.stplumpsumamount1;

        stpfundName = data.STP_fundName;
        startDate = data.stpRedeemstartDate;
      } else if (data?.sipaction === "Switch") {
        stp = data.stpSwitch;
        frequency = data.stpSwitchFrequency;
        duration = data.stpSwitchDuration;
        lumpSumAmount = data?.stpSwitchlumpSumAmount;
        // lumpSumAmount = data?.allUnitsSwitch === "no"? data?.transactionAmountSwitch : data?.stpSwitchlumpSumAmount;
        // data?.allUnitsSwitch === "no"? data?.transactionAmountSwitch
        //   : data?.redeemStp === "no"? isGoalResponse?.currentval 
        //   : data?.stpSwitchlumpSumAmount;

        stpfundName = data.stpSwitchfundName;
        startDate = data.stpStartDateSwitch;
      }

      // ✅ Extract activesips object
      // const activesips = activeSips.reduce((acc, sip) => {
      //   if (stopSipSelection[sip._id]) {
      //     acc[sip._id] = sip.sip_amount;
      //   }
      //   return acc;
      // }, {});
      // const allDataredeem = {
      //   sipaction: action || "",

      //   // ----------sip_stop--------
      //   startasip: data.startasip || "",
      //   stoptsip: action ==='sip_stop '? "yes":'',
      //   restartfundname: action ==='sip_stop '? data.fundNameRedeem || "":'',
      //   siprestartamount: action ==='sip_stop '? data.sipAmountSIP || "":'',
      //   stopsip_amc: action ==='sip_stop '? data.amcHouseRedeem || "":'',
      //   siprestartdate:action ==='sip_stop '? data.sipStartDate || "":'',
      //   siprePerpetual:action ==='sip_stop '? data?.perpetualSIP || "":'',
      //   stopsip_enddate:action ==='sip_stop '? data.sipEndDate || "":'',
      //   // activesips: activesips || {},
      //   // goalName in redeem section already set
      //   // "goalYear": "2040",
      //   // "startYear": "2025",
      //   // ----------sip_stop End--------

      //   // --------Redeem Start----------
      //   allunites: data?.allUnitsRedeem || "",
      //   no_ofunites:data?.allUnitsRedeem==='no'? data?.transactionAmountRedeem:generateEiFormData?.currentval,
      //   reinvest: data.reInvest || "",
      //   goalName: data?.goalNameRedeem || preGoalName || "",
      //   limpsuamt: data?.reInvest==="no"? "":data.lumpSumAmountRedeem || "",
      //   selectfundhouse: data.amcHouseRedeem || "",
      //   selectfund: data.fundNameRedeem || "",
      //   lumpsuamtount: "",
      //   selectfundlumpsum: "",

      //   isreviewed: 1,

      //   redeem_stp: stp || "",
      //   STP_fundName: stpfundName || "",
      //   stpdurationmonth: duration || "",
      //   STP_Frequency: frequency || "",
      //   stplumpsumamount: Number(lumpSumAmount) || "",
      //   stpstartdate: startDate || "",

      //   redeem_stp1: data.redeem_stp1 || "no",
      //   STP_fundName1: data.STP_fundName1 || "",
      //   stpdurationmonth1: data.stpdurationmonth1 || "",
      //   STP_Frequency1: data.STP_Frequency1 || "",
      //   stplumpsumamount1: data.stplumpsumamount11 || "",
      //   stpstartdate1: stpRedeemstartDate1 || "",

      //   redeem_stp2: data.redeem_stp2 || "no",
      //   STP_fundName2: data.STP_fundName2 || "",
      //   stpdurationmonth2: data.stpdurationmonth2 || "",
      //   STP_Frequency2: data.STP_Frequency2 || "",
      //   stplumpsumamount2: data.stplumpsumamount12 || "",
      //   stpstartdate2: stpRedeemstartDate2 || "",

      //   alluniteswitch: data.allUnitsSwitch || "",
      //   no_ofunites_switch: action==='Switch'? Number(data?.transactionAmountSwitch)?.toFixed(0) :'',
      //   switchfund: data.switchInFund || "",
      //   swp_frequency: "",
      //   swp_amount: "",
      //   swp_startdate: "",
      //   swp_tenor: "",

      //   sipfundname:action==='SIP'? data.amcHouseRedeem : "",
      //   goalNameStart: generateEiFormData?.goal_name || "",
      //   sipfrequency: action==='SIP'? "Monthly":'',
      //   siptypeaction: data?.sipaction || "",
      //   isSIP: data?.sipaction === "Switch" ? 0 : generateEiFormData?.isSIP,

      //   schemename: generateEiFormData?.schemename || "",
      //   portfolioid: generateEiFormData?.portfolioid || "",
      //   currentval: generateEiFormData?.currentval || "",
      //   clientid: generateEiFormData?.clientid || "",
      //   ISIN: generateEiFormData?.ISIN || "",
      //   moneyformatecurval: generateEiFormData?.moneyformatecurval || "",
      //   fundname: invFundname || generateEiFormData?.reinvest_fund || "",
      //   startYear: invStartYear || "",
      //   goalYear: invGoalYear || "",
      //   goalNamePre: invGoalName || "",
      //   goalIdPre: invGoalId || "",
      //   act: "submit",
      //   test: "test4",
      // };

       // helpers
       
 
 
       const allDataredeem = makePayload(action, data, generateEiFormData, {
        //  activesips,
         stp, stpfundName, duration, frequency,
         lumpSumAmount, startDate,
         stpRedeemstartDate1, stpRedeemstartDate2,
         invStartYear, invGoalYear, preGoalName,
       });
       
       console.log("allDataredeem", allDataredeem, data);

      // console.log("allDataredeem", generateEiFormData, allDataredeem, data);

      //   // sip allowed
      try {
        const response = await api.post(
          `advisor/saveExternalportfolio`,
          allDataredeem
        );

        const errs = response?.data?.errors;

        // console.log("saveExternalportfolio redeem response",  response.data.errors.stpdurationmonth);


        // Handle validation errors
        if (response.data.status === false && response.data.errors && Object.keys(response.data.errors).length > 0) {
          console.log("saveExternalportfolio", response.data.errors);

          // ---------------switch--------------
          // if (response.data.errors.no_ofunites_switch) {
          //   setError("transactionAmountSwitch", {
          //     type: "manual",
          //     message: response.data.errors.no_ofunites_switch,
          //   });
          // } else {
          //   clearErrors("transactionAmountSwitch");
          // }

          const noOfUnitesSwitchMsg = Array.isArray(errs)
            ? (errs[0]?.no_ofunites_switch || errs[0]?.eino_ofunites_switch)
            : undefined;

          if (noOfUnitesSwitchMsg) {
            setError("transactionAmountSwitch", {
              type: "server",
              message: noOfUnitesSwitchMsg,
            });
          } else {
            clearErrors("transactionAmountSwitch");
          }

          if (response.data.errors.stpdurationmonth) {
            setError("stpSwitchDuration", {
              type: "manual",
              message: response.data.errors.stpdurationmonth,
            });
          } else {
            clearErrors("stpSwitchDuration");
          }

          if (action === "switch" && response.data.errors.stplumpsumamount) {
            setError("stpSwitchlumpSumAmount", {
              type: "manual",
              message: response.data.errors.stplumpsumamount,
            });
          } else {
            clearErrors("stpSwitchlumpSumAmount");
          }

          // if (response.data.errors.no_ofunites) {
          //   setError("transactionAmountRedeem", {
          //     type: "manual",
          //     message: response.data.errors.no_ofunites,
          //   });
          // } else {
          //   clearErrors("transactionAmountRedeem");
          // }

          // assuming you have setError / clearErrors from useForm()

          // Option A: find key inside any error object
          const noOfUnitsMsg = Array.isArray(errs)
            ? errs.find((e) => typeof e?.no_ofunites === "string")?.no_ofunites
            : undefined;

          if (noOfUnitsMsg) {
            setError("transactionAmountRedeem", {
              type: "server",
              message: noOfUnitsMsg,
            });
          } else {
            clearErrors("transactionAmountRedeem");
          }

          if (response.data.errors.switchfund) {
            setError("switchInFund", {
              type: "manual",
              message: response.data.errors.switchfund,
            });
          } else {
            clearErrors("switchInFund");
          }

          if (response.data.errors.stpdurationmonth) {
            setError("stpDurationMonthRedeem", {
              type: "manual",
              message: response.data.errors.stpdurationmonth,
            });
          } else {
            clearErrors("stpDurationMonthRedeem");
          }

          // if (response.data.errors.limpsuamt) {
          //   setError("lumpSumAmountRedeem", {
          //     type: "manual",
          //     message: response.data.errors.limpsuamt,
          //   });
          // } else {
          //   clearErrors("lumpSumAmountRedeem");
          // }
          const lumpSumMsg = Array.isArray(errs)
            ? errs[0]?.limpsuamt
            : undefined;

          if (lumpSumMsg) {
            setError("lumpSumAmountRedeem", {
              type: "server",
              message: lumpSumMsg,
            });
          } else {
            clearErrors("lumpSumAmountRedeem");
          }

          if (response.data.errors.stplumpsumamount) {
            setError("stplumpsumamount1", {
              type: "manual",
              message: response.data.errors.stplumpsumamount,
            });
          } else {
            clearErrors("stplumpsumamount1");
          }

          if (response.data.errors.STP_fundName) {
            setError("STP_fundName", {
              type: "manual",
              message: response.data.errors.STP_fundName,
            });
          } else {
            clearErrors("STP_fundName");
          }

          // ----redeem stp2------
          if (response.data.errors.stplumpsumamount2) {
            setError("stplumpsumamount12", {
              type: "manual",
              message: response.data.errors.stplumpsumamount2,
            });
          } else {
            clearErrors("stplumpsumamount12");
          }

          // -------------STP-----------

          if (action === "STP" && response.data.errors.stplumpsumamount) {
            setError("lumpSumAmountSTP", {
              type: "manual",
              message: response.data.errors.stplumpsumamount,
            });
          } else {
            clearErrors("lumpSumAmountSTP");
          }

          if (response.data.errors.stpdurationmonth) {
            setError("durationSTP", {
              type: "manual",
              message: response.data.errors.stpdurationmonth,
            });
          } else {
            clearErrors("durationSTP");
          }
        } else if (
          response.data.status === true
          // && response.data.message !== ""
        ) {
          onHide(true);
          Swal.fire({
            title: "Success",
            icon: "success",
            html: response.data.message,
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "swal-confirm-btn",
            },
          }).then(() => {
            // setIsActionMessage(response.data.message);
            // onActionUpdate(
            //   rowKey,
            //   response.data.message,
            //   response.data.scheme_code
            // );
            // onActionSchemeCode(rowKey, response.data.scheme_code);
            socket.emit("join", { room: roomId });
            socket.emit("message_to",
              {
                room: roomId,
                data: {
                  message: response?.data?.message || "Client data updated successfully",
                  type: "success",
                }

              })
            fetchGetEiFolioData();
            resetModalStates();
          });
        }
      } catch (error) {
        console.error("Error saving portfolio:", error);

        // Optional: show user-friendly error alert
        Swal.fire({
          title: "Error",
          text:
            error?.response?.data?.message ||
            "Something went wrong. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-confirm-btn",
          },
        });
      }

      //   success: function (response)
      //   {
      //     const obj = JSON.parse(response);
      //     $('#suscessmsg').removeAttr("style");
      //     $('#suscessmsg').html(obj.message);
      //     if(obj.message=='')
      //     {
      //       $('#suscessmsg').hide();
      //     }
      //     else
      //     {
      //       $('#suscessmsg').hide();
      //     }
      //     if($.isEmptyObject(obj.errors)==true)
      //     {
      //       portfolioidid = $('#portfolioid').val();
      //       ISIN = $('#ISIN').val();
      //       portfolioidid = portfolioidid.replace("/","_");
      //       actremrkhtml = '#remarkact_'+portfolioidid+ISIN;
      //       var rowhtml = '#foliorow_'+portfolioidid+ISIN;
      //       $(rowhtml).removeClass('w3-pale-red');
      //       $(rowhtml).addClass('w3-pale-green');
      //       setTimeout(function()
      //       {
      //         $(rowhtml).removeClass('w3-pale-green');
      //       }, 15000);
      //       //$(actremrkhtml).html(obj.message);
      //       var msgstring = removeTags(obj.message);
      //       $(actremrkhtml).html(msgstring);
      //       $('#exampleModal').modal('hide');
      //     }
      //   }
      // });
    }

    // const allData = {

    //     act: "submit",
    //     sipaction: action,
    //     allunites: allUnits || "",
    //     no_ofunites: "",
    //     reinvest: reInvest || "",
    //     // Goal Name
    //     limpsuamt: "",
    //     selectfundhouse: "",
    //     selectfund: "",
    //     lumpsuamtount: "",
    //     selectfundlumpsum: "",

    //     alluniteswitch: allUnitsSwitch || "",
    //     no_ofunites_switch: transactionAmountSwitch||"",
    //     switchfund: switchInFund || "",
    //     swp_frequency: stpSwitchFrequency || "",
    //     // STP Duration (Months)
    //     // Lump Sum Amount
    //     // Select Switch In Fund
    //     swp_amount: "",
    //     swp_startdate: "",
    //     swp_tenor: "",

    //     sipfundname: "",
    //     goalNameStart: "Goal" || "",
    //     sipstartdate: selectedSipStartDate || "",
    //     sipamount: isSipAmount || "",
    //     sipfrequency: "Monthly" || "",
    //     sipPerpetual: perpetualSIP||"",
    //     sipenddate: selectedSIPEndDate|'',

    //     redeem_stp: allUnitsSwitch||"",
    //     STP_Frequency: frequencySTP || stpSwitchFrequency|| "",
    //     stpdurationmonth: isStpDuration ||stpSwitchDuration|| "",
    //     stplumpsumamount: isStpLumpSumAmount || stpSwitchlumpSumAmount|| "",
    //     STP_fundName: stpInFund ||stpSwitchInFund|| "",
    //     stpstartdate: selectedStpStartDate || selectedStpSwitchStartDate||"",

    //     eiisreviewed: isReviewed || "",
    //     eisiptypeaction: generateEiFormData?.sipaction || "",
    //     schemename: generateEiFormData?.schemename || "",
    //     amc_code: generateEiFormData?.amc_code || "",
    //     portfolioid: generateEiFormData?.portfolioid || "",
    //     currentval: generateEiFormData?.currentval || "",
    //     clientid: generateEiFormData?.clientid || "",
    //     ISIN: generateEiFormData?.ISIN || "",
    //     isSIP: generateEiFormData?.isSIP || 0,
    //     moneyformatecurval: "",
    //     fundname: generateEiFormData?.fundname || "",
    //     fundhousename: generateEiFormData?.amcname || "",
    //     startYear: generateEiFormData?.fromStartDate || "",
    //     goalYear: 0 || "",
    //     goalNamePre: generateEiFormData?.goalName,
    //     goalIdPre: generateEiFormData?.goalId

    // }
    // // console.log("allData", allData);

    // if (isCheckedit != 1) {
    //   // console.log("sipFormData", allData, isCheckedit, goalDetails?.goalId);
    //   if (sipAction === 'SIP') {
    //   console.log("sipFormData1", allData, isCheckedit, goalDetails?.goalId);

    //     try {
    //       const response = await api.post(
    //         `advisor/saveExternalportfolio`,
    //         allData
    //       );
    //       const obj = response.data;
    //       console.log("obj", obj);
    //       setIsLabel(obj.message || '')
    //       fetchGetEiFolioData()

    //     } catch (error) {
    //       console.error("Error saving data", error);
    //     }
    //   }

    //   else if (reInvest === 'yes') {
    //     // console.log("reInvestyes", allData, isCheckedit, goalDetails?.goalId);

    //     let goalId = generateEiFormData?.goalId

    //     const data = goalDetails;

    //     let invGoalId = data?.goalId

    //     let runningSIP = parseInt(data?.runningSIP) || 0;
    //     let aum = data?.accumulatedAmount;
    //     let cagr = parseInt(data?.expectedReturn);
    //     let goalYear = parseInt(data?.goalYear);
    //     let startYear = parseInt(data?.startyear);
    //     let goalName = data?.goalname;
    //     let targetAmount = parseInt(data.TargetAmount.toString().trim())
    //     let remainingMonth = (goalYear - startYear) * 12;
    //     let goalNameRedeem = data?.goalName

    //     if (reInvest === 'yes' && goalNameRedeem === '') {
    //       Swal.fire({
    //         text: 'Please Select a Goal to Invest',
    //         icon: 'error',
    //         confirmButtonText: 'OK',
    //         customClass: {
    //           confirmButton: 'swal-confirm-btn',
    //         },

    //       });
    //       setReInvest('no')
    //       return false;
    //     } else {
    //       // console.log("reInvestyes else", allData, isCheckedit, goalDetails?.goalId);

    //       newSIP = 0;
    //       var finalCorpus = 0;
    //       // console.log("goalId==invGoalId",goalId,invGoalId);

    //       if (goalId == invGoalId) {
    //       console.log("goalId==invGoalId", allData, isCheckedit, goalDetails?.goalId);

    //         if (allUnits == 'yes') {
    //           // console.log("goalId",goalId,invGoalId);
    //           aum = Math.round(lumpSumAmountRedeem);
    //         } else {
    //           aum = aum - isNoUofUnit + Math.round(lumpSumAmountRedeem);
    //         }
    //         var oneTimeInvFutureVal = aum * Math.pow((1 + cagr / 100), (goalYear - startYear));
    //         var capitalGrowth = 0;
    //         var monthEndValue = 0;
    //         finalCorpus = 0;
    //         var totalSIP = runningSIP + newSIP;

    //         for (var i = 1; i < remainingMonth; i++) {
    //           capitalGrowth = (monthEndValue + totalSIP) * cagr / 1200;
    //           monthEndValue = monthEndValue + capitalGrowth + totalSIP;
    //           console.log("sipFormData",goalDetails,totalSIP,cagr,capitalGrowth,monthEndValue,);

    //         }
    //         monthEndValue = monthEndValue + totalSIP;
    //         console.log("sipFormData2", targetAmount, monthEndValue);

    //         finalCorpus = Math.round(monthEndValue) + Math.round(oneTimeInvFutureVal);
    //         console.log("bmw", oneTimeInvFutureVal, monthEndValue);

    //         if (finalCorpus < targetAmount) {
    //           // ok;
    //           // $('#startYear').val(startYear);
    //           // $('#goalYear').val(goalYear);
    //           const payload = {
    //             act: "submit",
    //             sipaction: action,
    //             allunites: allUnits || "",
    //             no_ofunites: isNoUofUnit,
    //             reinvest: reInvest || "",
    //             // Goal Name
    //             limpsuamt: lumpSumAmountRedeem,
    //             selectfundhouse: selectedAmcHouse,
    //             selectfund: fundNameRedeem,
    //             lumpsuamtount: "",
    //             selectfundlumpsum: "",

    //             alluniteswitch: allUnitsSwitch || "",
    //             no_ofunites_switch: "",
    //             switchfund: "",
    //             swp_frequency: "",
    //             // STP Duration (Months)
    //             // Lump Sum Amount
    //             // Select Switch In Fund
    //             swp_amount: "",
    //             swp_startdate: "",
    //             swp_tenor: "",

    //             sipfundname: "",
    //             goalNameStart: "Goal",
    //             sipstartdate: "",
    //             sipamount: "",
    //             sipfrequency: "Monthly",
    //             sipPerpetual: "",
    //             sipenddate: "",

    //             redeem_stp: "",
    //             STP_Frequency: "",
    //             stpdurationmonth: "",
    //             stplumpsumamount: "",
    //             STP_fundName:'',

    //             eiisreviewed: isReviewed || "",
    //             eisiptypeaction: generateEiFormData?.sipaction || "",
    //             schemename: generateEiFormData?.schemename || "",
    //             amc_code: generateEiFormData?.amc_code || "",
    //             portfolioid: generateEiFormData?.portfolioid || "",
    //             currentval: generateEiFormData?.currentval || "",
    //             clientid: generateEiFormData?.clientid || "",
    //             ISIN: generateEiFormData?.ISIN || "",
    //             isSIP: generateEiFormData?.isSIP || 0,
    //             moneyformatecurval: "",
    //             fundname: generateEiFormData?.fundname || "",
    //             fundhousename: generateEiFormData?.amcname || "",
    //             startYear: generateEiFormData?.fromStartDate || "",
    //             goalYear: 0 || "",
    //             goalNamePre: generateEiFormData?.goalName,
    //             goalIdPre: generateEiFormData?.goalId
    //           }

    //           console.log("sipFormData23", payload);

    //           try {
    //             setUpdate(true)
    //             const response = await api.post(
    //               `advisor/saveExternalportfolio`,
    //               payload
    //             );
    //             const obj = response.data;
    //             console.log("obj", obj);
    //             setIsLabel(obj.message)
    //             fetchGetEiFolioData()
    //             onHide();
    //           } catch (error) {
    //             console.error("Error saving data", error);
    //           } finally {
    //             setUpdate(false)
    //             setIsLabel('')
    //           }

    //         } else {
    //           var diff = finalCorpus - targetAmount;
    //           console.log("d3",diff, finalCorpus , targetAmount);

    //           Swal.fire({
    //             title: 'Oops! Cannot exceed Goal Target',
    //             text: 'This investment will take the projected achievement to ' + (finalCorpus) + ', which is ' + (diff) + ' higher than the Goal Target of ' + (targetAmount) + '.',
    //             icon: 'error',
    //             confirmButtonText: 'OK',
    //             customClass: {
    //               confirmButton: 'swal-confirm-btn',
    //             },
    //           });
    //         }
    //       }
    //       else {
    //       // console.log("goalId!==invGoalId", finalCorpus, targetAmount);

    //         if (finalCorpus < targetAmount) {
    //           // ok;
    //           // $('#startYear').val(startYear);
    //           // $('#goalYear').val(goalYear);
    //           const payload = {
    //             act: "submit",
    //             sipaction: action,
    //             allunites: allUnits || "",
    //             no_ofunites: isNoUofUnit,
    //             reinvest: reInvest || "",
    //             // Goal Name
    //             limpsuamt: lumpSumAmountRedeem,
    //             selectfundhouse: selectedAmcHouse,
    //             selectfund: fundNameRedeem,
    //             lumpsuamtount: "",
    //             selectfundlumpsum: "",

    //             alluniteswitch: allUnitsSwitch || "",
    //             no_ofunites_switch: "",
    //             switchfund: "",
    //             swp_frequency: "",
    //             // STP Duration (Months)
    //             // Lump Sum Amount
    //             // Select Switch In Fund
    //             swp_amount: "",
    //             swp_startdate: "",
    //             swp_tenor: "",

    //             sipfundname: "",
    //             goalNameStart: "Goal",
    //             sipstartdate: "",
    //             sipamount: "",
    //             sipfrequency: "Monthly",
    //             sipPerpetual: "",
    //             sipenddate: "",

    //             redeem_stp: "",
    //             STP_Frequency: "",
    //             stpdurationmonth: "",
    //             stplumpsumamount: "",
    //             STP_fundName: stpInFund||'',
    //             stpstartdate: "",

    //             eiisreviewed: isReviewed || "",
    //             eisiptypeaction: generateEiFormData?.sipaction || "",
    //             schemename: generateEiFormData?.schemename || "",
    //             amc_code: generateEiFormData?.amc_code || "",
    //             portfolioid: generateEiFormData?.portfolioid || "",
    //             currentval: generateEiFormData?.currentval || "",
    //             clientid: generateEiFormData?.clientid || "",
    //             ISIN: generateEiFormData?.ISIN || "",
    //             isSIP: generateEiFormData?.isSIP || 0,
    //             moneyformatecurval: "",
    //             fundname: generateEiFormData?.fundname || "",
    //             fundhousename: generateEiFormData?.amcname || "",
    //             startYear: generateEiFormData?.fromStartDate || "",
    //             goalYear: 0 || "",
    //             goalNamePre: generateEiFormData?.goalName,
    //             goalIdPre: generateEiFormData?.goalId
    //           }
    //           // console.log("sipFormData23", payload);
    //           try {
    //             setUpdate(true)
    //             const response = await api.post(
    //               `advisor/saveExternalportfolio`,
    //               payload
    //             );
    //             const obj = response.data;
    //             console.log("obj", obj);
    //             fetchGetEiFolioData()
    //             setIsLabel(obj.message)
    //             onHide();
    //           } catch (error) {
    //             console.error("Error saving data", error);
    //           } finally {
    //             setUpdate(false)
    //             setIsLabel('')
    //           }

    //         } else {
    //           var diff = finalCorpus - targetAmount;
    //           // console.log("d2",diff, finalCorpus , targetAmount);

    //           Swal.fire({
    //             title: 'Oops! Cannot exceed Goal Target',
    //             text: 'This investment will take the projected achievement to ' + (finalCorpus) + ', which is ' + (diff) + ' higher than the Goal Target of ' + (targetAmount) + '.',
    //             icon: 'error',
    //             confirmButtonText: 'OK',
    //             customClass: {
    //               confirmButton: 'swal-confirm-btn',
    //             },
    //           });
    //         }

    //         // var clientid = $("#clientid").val();
    //         // $.ajax(
    //         // {
    //         //   url: '<?php echo site_url(); ?>Eifolioreviews/getGoalData',
    //         //   data: {goalId:invGoalId,client_id:clientid},
    //         //   type: 'post',
    //         //   success: function (response)
    //         //   {
    //         //     var result = JSON.parse(response);
    //         //     aum = Math.round($('#eilimpsuamt').val());

    //         //     runningSIP = parseInt(result.runningSIP);
    //         //     if(result.runningSIP==null)
    //         //     {
    //         //       runningSIP=0;
    //         //     }
    //         //     cagr = parseInt(result.Expectedreturn);
    //         //     goalYear = parseInt(result.targetyear);
    //         //     startYear = parseInt(result.startyear);
    //         //     if(result.pfundvalue!=='undefined' && result.pfundvalue!='')
    //         //     {
    //         //       targetAmount = (result.pfundvalue).replace(/\D/g, '');
    //         //     }
    //         //     else if(result.projectedamount!=='undefined' && result.projectedamount!='')
    //         //     {
    //         //       targetAmount = (result.projectedamount).replace(/\D/g, '');
    //         //     }
    //         //     else if(result.downpaymentrs!=='undefined' && result.downpaymentrs!='')
    //         //     {
    //         //       targetAmount = (result.downpaymentrs).replace(/\D/g, '');
    //         //     }
    //         //     else if(result.Targetamount!=='undefined' && result.Targetamount!='')
    //         //     {
    //         //       targetAmount = (result.Targetamount).replace(/\D/g, '');
    //         //     }
    //         //     remainingMonth = (goalYear - startYear)*12;
    //         //     var oneTimeInvFutureVal = aum*Math.pow((1+cagr/100),(goalYear - startYear));
    //         //     var capitalGrowth = 0;
    //         //     var monthEndValue = 0,finalCorpus=0;
    //         //     var totalSIP = runningSIP + newSIP;
    //         //     for(var i=1;i<remainingMonth;i++)
    //         //     {
    //         //       capitalGrowth = (monthEndValue + totalSIP)*cagr/1200;
    //         //       monthEndValue = monthEndValue + capitalGrowth + totalSIP;
    //         //     }
    //         //     monthEndValue = monthEndValue + totalSIP;
    //         //     finalCorpus = Math.round(monthEndValue) + Math.round(oneTimeInvFutureVal);
    //         //     if(finalCorpus<targetAmount)
    //         //     {
    //         //       // ok
    //         //       $('#startYear').val(startYear);
    //         //       $('#goalYear').val(goalYear);

    //         //       $.ajax(
    //         //       {
    //         //         url: '<?php echo site_url(); ?>Eifolioreviews/saveExternalportfolio?act=submit',
    //         //         data: $('#eisipform').serialize(),
    //         //         type: 'post',
    //         //         success: function (response)
    //         //         {
    //         //           const obj = JSON.parse(response);
    //         //           $('#suscessmsg').removeAttr("style");
    //         //           $('#suscessmsg').html(obj.message);
    //         //           if(obj.message=='')
    //         //           {
    //         //             $('#suscessmsg').hide();
    //         //           }
    //         //           else
    //         //           {
    //         //             $('#suscessmsg').hide();
    //         //           }
    //         //           if($.isEmptyObject(obj.errors)==true)
    //         //           {
    //         //             portfolioidid = $('#eiportfolioid').val();
    //         //             ISIN = $('#ISIN').val();
    //         //             portfolioidid = portfolioidid.replace("/","_");
    //         //             actremrkhtml = '#remarkact_'+portfolioidid+ISIN;
    //         //             var rowhtml = '#foliorow_'+portfolioidid+ISIN;
    //         //             $(rowhtml).removeClass('w3-pale-red');
    //         //             $(rowhtml).addClass('w3-pale-green');
    //         //             setTimeout(function()
    //         //             {
    //         //               $(rowhtml).removeClass('w3-pale-green');
    //         //             }, 15000);
    //         //             //$(actremrkhtml).html(obj.message);
    //         //             var msgstring = removeTags(obj.message);
    //         //             $(actremrkhtml).html(msgstring);
    //         //             $('#externalinvswitchModel').modal('hide');
    //         //           }
    //         //         }
    //         //       });
    //         //     }else
    //         //     {
    //         //       var diff = finalCorpus - targetAmount;
    //         //       Swal.fire({
    //         //           title: 'Oops! Cannot exceed Goal Target',
    //         //           text: 'This investment will take the projected achievement to '+moneyChange(finalCorpus)+', which is '+moneyChange(diff)+' higher than the Goal Target of '+moneyChange(targetAmount)+'.',
    //         //           icon: 'error'
    //         //       });
    //         //     }
    //         //   }
    //         // });
    //       }
    //       return;
    //     }
    //   }

    //   else {
    //   console.log("sipFormData3", allData, isCheckedit, goalDetails?.goalId);

    //     // console.log("sipFormData",reInvest);
    //     console.log("sipFormData", goalId, invGoalId);
    //     newSIP = 0;
    //     if (goalId === invGoalId) {
    //       if (reInvest === 'yes') {
    //         aum = Math.round(reInvestLumpsumamt);
    //       } else {
    //         aum = aum - transactionAmountRedeem + Math.round(reInvestLumpsumamt);
    //       }

    //       var oneTimeInvFutureVal = aum * Math.pow((1 + cagr / 100), (goalYear - startYear));
    //       var capitalGrowth = 0;
    //       var monthEndValue = 0, finalCorpus = 0;
    //       var totalSIP = runningSIP + newSIP;
    //       for (var i = 1; i < remainingMonth; i++) {
    //         capitalGrowth = (monthEndValue + totalSIP) * cagr / 1200;
    //         monthEndValue = monthEndValue + capitalGrowth + totalSIP;
    //       }
    //       monthEndValue = monthEndValue + totalSIP;
    //       finalCorpus = Math.round(monthEndValue) + Math.round(oneTimeInvFutureVal);
    //       if (finalCorpus < targetAmount) {
    //         {
    //           try {
    //             const response = await api.post(
    //               `advisor/saveExternalportfolio`,
    //               allData
    //             );
    //             const obj = response.data;
    //             console.log("obj", obj);
    //             fetchGetEiFolioData()
    //             setIsLabel(obj.message || '')

    //           } catch (error) {
    //             console.error("Error saving data", error);
    //           }
    //         }
    //       }
    //       else {
    //         var diff = finalCorpus - targetAmount;
    //         console.log("d1",diff, finalCorpus , targetAmount);

    //         Swal.fire({
    //           title: 'Oops! Cannot exceed Goal Target',
    //           text: 'This investment will take the projected achievement to ' + (finalCorpus) + ', which is ' + (diff) + ' higher than the Goal Target of ' + (targetAmount) + '.',
    //           icon: 'error',
    //           confirmButtonText: 'OK',
    //             customClass: {
    //               confirmButton: 'swal-confirm-btn',
    //             },
    //         });
    //       }
    //     } else {
    //       var clientid = generateEiFormData?.clientid;

    //       //  STP PAYLOAD
    //       const payload = {
    //         act: "submit",
    //         sipaction: action,
    //         allunites: allUnits || "",
    //         no_ofunites: "",
    //         reinvest: reInvest || "",
    //         // Goal Name
    //         limpsuamt: "",
    //         selectfundhouse: "",
    //         selectfund: "",
    //         lumpsuamtount: "",
    //         selectfundlumpsum: "",

    //         alluniteswitch: allUnitsSwitch || "",
    //         no_ofunites_switch: transactionAmountSwitch||"",
    //         switchfund: switchInFund || "",
    //         swp_frequency: stpSwitchFrequency || "",
    //         // STP Duration (Months)
    //         // Lump Sum Amount
    //         // Select Switch In Fund
    //         swp_amount: "",
    //         swp_startdate: "",
    //         swp_tenor: "",

    //         sipfundname: "",
    //         goalNameStart: "Goal" || "",
    //         sipstartdate: selectedSipStartDate || "",
    //         sipamount: isSipAmount || "",
    //         sipfrequency: "Monthly" || "",
    //         sipPerpetual: "",
    //         sipenddate: selectedSIPEndDate|'',

    //         redeem_stp: allUnitsSwitch||"",
    //         STP_Frequency: frequencySTP || stpSwitchFrequency|| "",
    //         stpdurationmonth: isStpDuration ||stpSwitchDuration|| "",
    //         stplumpsumamount: isStpLumpSumAmount || stpSwitchlumpSumAmount|| "",
    //         STP_fundName: stpInFund ||stpSwitchInFund|| "",
    //         stpstartdate: selectedStpStartDate || selectedStpSwitchStartDate||"",

    //         eiisreviewed: isReviewed || "",
    //         eisiptypeaction: generateEiFormData?.sipaction || "",
    //         schemename: generateEiFormData?.schemename || "",
    //         amc_code: generateEiFormData?.amc_code || "",
    //         portfolioid: generateEiFormData?.portfolioid || "",
    //         currentval: generateEiFormData?.currentval || "",
    //         clientid: generateEiFormData?.clientid || "",
    //         ISIN: generateEiFormData?.ISIN || "",
    //         isSIP: generateEiFormData?.isSIP || 0,
    //         moneyformatecurval: "",
    //         fundname: generateEiFormData?.fundname || "",
    //         fundhousename: generateEiFormData?.amcname || "",
    //         startYear: generateEiFormData?.fromStartDate || "",
    //         goalYear: 0 || "",
    //         goalNamePre: generateEiFormData?.goalName,
    //         goalIdPre: generateEiFormData?.goalId
    //       }

    //       console.log("sipFormData23", payload);

    //       try {
    //         setUpdate(true)
    //         const response = await api.post(
    //           `advisor/saveExternalportfolio`,
    //           payload
    //         );
    //         const obj = response.data;
    //         fetchGetEiFolioData()   //call fun for refecth updated recomended action data of ei table
    //         console.log("obj", obj);
    //         setIsLabel(obj.message)
    //         onHide();
    //       } catch (error) {
    //         console.error("Error saving data", error);
    //       } finally {
    //         setUpdate(false)
    //         setIsLabel('')
    //       }

    //       // $.ajax(
    //       // {
    //       //   url: '<?php echo site_url(); ?>Eifolioreviews/getGoalData',
    //       //   data: {goalId:invGoalId,client_id:clientid},
    //       //   type: 'post',
    //       //   success: function (response)
    //       //   {
    //       //     var result = JSON.parse(response);
    //       //     aum = Math.round($('#eilimpsuamt').val());

    //       //     runningSIP = parseInt(result.runningSIP);
    //       //     if(result.runningSIP==null)
    //       //     {
    //       //       runningSIP=0;
    //       //     }
    //       //     cagr = parseInt(result.Expectedreturn);
    //       //     goalYear = parseInt(result.targetyear);
    //       //     startYear = parseInt(result.startyear);
    //       //     if(result.pfundvalue!=='undefined' && result.pfundvalue!='')
    //       //     {
    //       //       targetAmount = (result.pfundvalue).replace(/\D/g, '');
    //       //     }
    //       //     else if(result.projectedamount!=='undefined' && result.projectedamount!='')
    //       //     {
    //       //       targetAmount = (result.projectedamount).replace(/\D/g, '');
    //       //     }
    //       //     else if(result.downpaymentrs!=='undefined' && result.downpaymentrs!='')
    //       //     {
    //       //       targetAmount = (result.downpaymentrs).replace(/\D/g, '');
    //       //     }
    //       //     else if(result.Targetamount!=='undefined' && result.Targetamount!='')
    //       //     {
    //       //       targetAmount = (result.Targetamount).replace(/\D/g, '');
    //       //     }
    //       //     remainingMonth = (goalYear - startYear)*12;
    //       //     var oneTimeInvFutureVal = aum*Math.pow((1+cagr/100),(goalYear - startYear));
    //       //     var capitalGrowth = 0;
    //       //     var monthEndValue = 0,finalCorpus=0;
    //       //     var totalSIP = runningSIP + newSIP;
    //       //     for(var i=1;i<remainingMonth;i++)
    //       //     {
    //       //       capitalGrowth = (monthEndValue + totalSIP)*cagr/1200;
    //       //       monthEndValue = monthEndValue + capitalGrowth + totalSIP;
    //       //     }
    //       //     monthEndValue = monthEndValue + totalSIP;
    //       //     finalCorpus = Math.round(monthEndValue) + Math.round(oneTimeInvFutureVal);
    //       //     if(finalCorpus<targetAmount)
    //       //     {
    //       //       // ok
    //       //       $('#startYear').val(startYear);
    //       //       $('#goalYear').val(goalYear);

    //       //       $.ajax(
    //       //       {
    //       //         url: '<?php echo site_url(); ?>Eifolioreviews/saveExternalportfolio?act=submit',
    //       //         data: $('#eisipform').serialize(),
    //       //         type: 'post',
    //       //         success: function (response)
    //       //         {
    //       //           const obj = JSON.parse(response);
    //       //           $('#suscessmsg').removeAttr("style");
    //       //           $('#suscessmsg').html(obj.message);
    //       //           if(obj.message=='')
    //       //           {
    //       //             $('#suscessmsg').hide();
    //       //           }
    //       //           else
    //       //           {
    //       //             $('#suscessmsg').hide();
    //       //           }
    //       //           if($.isEmptyObject(obj.errors)==true)
    //       //           {
    //       //             portfolioidid = $('#eiportfolioid').val();
    //       //             ISIN = $('#ISIN').val();
    //       //             portfolioidid = portfolioidid.replace("/","_");
    //       //             actremrkhtml = '#remarkact_'+portfolioidid+ISIN;
    //       //             var rowhtml = '#foliorow_'+portfolioidid+ISIN;
    //       //             $(rowhtml).removeClass('w3-pale-red');
    //       //             $(rowhtml).addClass('w3-pale-green');
    //       //             setTimeout(function()
    //       //             {
    //       //               $(rowhtml).removeClass('w3-pale-green');
    //       //             }, 15000);
    //       //             //$(actremrkhtml).html(obj.message);
    //       //             var msgstring = removeTags(obj.message);
    //       //             $(actremrkhtml).html(msgstring);
    //       //             $('#externalinvswitchModel').modal('hide');
    //       //           }
    //       //         }
    //       //       });
    //       //     }else
    //       //     {
    //       //       var diff = finalCorpus - targetAmount;
    //       //       Swal.fire({
    //       //           title: 'Oops! Cannot exceed Goal Target',
    //       //           text: 'This investment will take the projected achievement to '+moneyChange(finalCorpus)+', which is '+moneyChange(diff)+' higher than the Goal Target of '+moneyChange(targetAmount)+'.',
    //       //           icon: 'error'
    //       //       });
    //       //     }
    //       //   }
    //       // });

    //     }
    //     return;
    //   }

    // }

    // else {
    //   if (goalYear != '') {
    //     try {
    //       setUpdate(true)
    //       const response = await api.post(
    //         `advisor/saveExternalportfolio`,
    //         allData
    //       );
    //       const obj = response.data;
    //       // console.log("objssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssss", obj);
    //       fetchGetEiFolioData()
    //       setIsLabel(obj.message || '')

    //     } catch (error) {
    //       console.error("Error saving data", error);

    //     } finally {
    //       setUpdate(false)
    //     }
    //   }
    // }
  };

  const resetSTP2Fields = () => {
    setStpRedeemstartDate_2(null);
    setValue("redeem_stp1", "no");
    setValue("STP_fundName1", "");
    setValue("stpdurationmonth1", "");
    setValue("STP_Frequency1", "");
    setValue("stpstartdate1", "");
  };

  const resetSTP3Fields = () => {
    setStpRedeemstartDate_2(null);
    setValue("redeem_stp2", "no");
    setValue("STP_fundName2", "");
    setValue("stpdurationmonth2", "");
    setValue("STP_Frequency2", "");
    setValue("stpstartdate2", "");
  };

  const resetModalStates = () => {
    reset(); // from react-hook-form
    setSipAction("");
    resetSTP2Fields();
    resetSTP3Fields();
    setStpRedeemstartDate_1(null);
    onHide(true);
  };

  const handleClose = () => {
    onHide(true);
    reset();
    setSipAction("");
    resetModalStates();
  };

  // redeem data
  const [allUnits, setAllUnits] = useState("");
  const [reInvest, setReInvest] = useState("");
  const goalNameRedeem = watch("goalNameRedeem");
  // console.log("redeem data",isLabel,sipaction,allUnits,reInvest,goalNameRedeem);

  const [reInvestLumpsumamt, setReInvestLumpsumamt] = useState("");
  const [fundNameList, setFundNameList] = useState([]);
  const lumpSumAmountRedeem = watch("lumpSumAmountRedeem");
  const fundNameRedeem = watch("fundNameRedeem");
  const transactionAmountRedeem = watch("transactionAmountRedeem");


  // switch data


  const [selectedSipStartDate, setSelectedSipStartDate] = useState(null);
  const [selectedSIPEndDate, setSelectedSIPEndDate] = useState(null);

  const eicheckfundbyamcCode = async (
    amc_code,
    client_id,
    portfolio_id,
    portfolio_ISIN
  ) => {
    // console.log("eicheckfundbyamcCode",amc_code,client_id,portfolio_id,portfolio_ISIN);

    try {
      const response = await api.post(`advisor/amcfundbyamccode`, {
        amc_code,
        client_id,
        portfolio_id,
        portfolio_ISIN,
      });
      setFundNameList(response?.data);
      // console.log("amcfundbyamccode :", response?.data,stpInFund);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // For get Goal Name  which is used to show goal name selector in SIP and Redeem sipaction
  const getGoal = async () => {
    try {
      const response = await api.get(`advisor/get_client_goal/${roomId}`);
      const data = response.data;
      setIsGoalData(data);
      return data;
    } catch (error) {
      console.error("Error fetching goal:", error);
    }
  };

  // Desired defaults (from preData / defaultValues)
  const desiredHouse = preData?.reinvest_amc
  const desiredFund = preData?.reinvest_fund
  const stopsipAmct = stopsip_amctW


  // 1) Modal open / house change par pehle AMC fund list lao
  useEffect(() => {
    if (!show) return;
    if (desiredHouse) {
      getAMCFundName(desiredHouse||stopsipAmct);   // yeh hi aapki API call hai
      setValue("amcHouseRedeem", desiredHouse, { shouldDirty: false });
      setValue('stopsip_amct',stopsipAmct)
    }
  }, [show, desiredHouse,stopsipAmct]);

  // 2) Jab list aa jaye aur usme desiredFund mil jaye, tabhi value set karo
  useEffect(() => {
    if (!show) return;
    if (!desiredFund) return;
    const hasFund = amcNameList?.some(f => f?.fund_name === desiredFund);
    if (hasFund) {
      setValue("fundNameRedeem", desiredFund, { shouldValidate: true, shouldDirty: false });
    }
  }, [show, amcNameList, desiredFund]);

  useEffect(() => {
    if (!show) return;
    // ek hi jagah form seed karo:
    reset({
      // jo fields aap set karna chahte ho:
      sipaction: preData?.action || "none",
      reInvest: preData?.is_reinvest || "",
      goalNameRedeem: preData?.investing_goal || preGoalName || "",
      lumpSumAmountRedeem: preData?.reinvest_lumpsumamt || "",
      amcHouseRedeem: desiredHouse || "",
      fundNameRedeem: desiredFund || "",
      // ...baaki jo bhi defaults hain
    }, { keepDirty: false, keepErrors: false });
  }, [show, preData, reset]);
  
  useEffect(() => {
    if (
      isGoalResponse &&
      isGenerateEIFormResponse?.body?.clientreviewedfolio?.length > 0
    ) {
      setIsReviewed(1);
      const data = isGenerateEIFormResponse.body;
      const goal = isGoalResponse?.[0];
      const switchfundlist = data?.switchfundlist;
      const sipactiontaken = data?.sipaction;
      const ISIN = data?.ISIN;
      const portfolioid = data?.portfolioid;
      const clientid = data?.clientid;
      console.log("clientReviewedFolio", data);
      setValue("goalNameRedeem", `${goal?.investing_goal}|${goal?.invGoalID}`);

      placeEIFormData(clientid, portfolioid, sipactiontaken, ISIN);
    }
  }, [isGoalResponse]);

  const placeEIFormData = async (
    clientid,
    portfolioid,
    sipactiontaken,
    ISIN
  ) => {
    setPreData({});
    try {
      setCheckedit(1);
      // console.log("dd",clientid,portfolioid,sipactiontaken,ISIN);
      const response = await api.post(`advisor/getEIreviewddata`, {
        clientid: clientid,
        portfolioid: portfolioid,
        ISIN: ISIN,
      });
      console.log("setCheckedit", response?.data?.reviewddata);

      setPreData(response?.data?.reviewddata);
      // if (response?.data?.status) {
      //   const portfoliodata = response?.data?.reviewddata;
      //   const action = portfoliodata?.action;

      //   // setIsLabel(portfoliodata?.recommended_action?.replace(/<[^>]*>/g, ""));
      //   setSipAction(action);
      //   setCheckedit(0);

      //   switch (action) {
      //     case "Redeem":
      //       if (sipactiontaken !== "Redeem") return;

      //       console.log(
      //         "portfoliodata Redeem:",
      //         portfoliodata,
      //         sipactiontaken,
      //         clientid,
      //         portfolioid,
      //         ISIN
      //       );
      //       setAllUnits(portfoliodata.allunites);

      //       if (portfoliodata.allunites === "no") {
      //         setValue("transactionAmountRedeem", portfoliodata.no_of_unites);
      //       } else {
      //         setReInvest(portfoliodata.is_reinvest);
      //         if (portfoliodata.is_reinvest === "yes") {
      //           setReInvestLumpsumamt(portfoliodata.reinvest_lumpsumamt);
      //           setValue("goalNameRedeem", portfoliodata.reinvest_fund);
      //           setValue("amcHouseRedeem", portfoliodata.reinvest_amc);
      //           setValue("fundNameRedeem", portfoliodata.reinvest_fund);
      //           setSTP(portfoliodata.is_stp);

      //           if (portfoliodata.is_stp === "yes") {
      //             setValue("stpInFund", portfoliodata.stp_fundname);
      //             // need to add required data
      //           }
      //         }
      //       }
      //       break;

      //     case "STP":
      //       if (sipactiontaken !== "STP") return;
      //       // here amc code not occuring thats why commented
      //       // eicheckfundbyamcCode(portfoliodata.amc_code,portfoliodata.client_id, portfoliodata.portfolio_id, portfoliodata.portfolio_ISIN);

      //       console.log(
      //         "portfoliodata STP:",
      //         portfoliodata,
      //         sipactiontaken,
      //         clientid,
      //         portfolioid,
      //         ISIN
      //       );
      //       setValue("frequencySTP", portfoliodata.frequency || ""); //need to improve
      //       setValue("durationSTP", portfoliodata.duration || ""); //need to improve
      //       setValue("lumpSumAmountSTP", portfoliodata.lumpsum_amount || ""); //need to improve
      //       setValue("stpInFund", portfoliodata.stp_fundname || ""); //need to improve
      //       setSelectedStpStartDate(portfoliodata.start_date || null); //need to improve
      //       break;

      //     case "SIP":
      //       if (sipactiontaken !== "SIP") return;
      //       console.log(
      //         "portfoliodata SIP:",
      //         portfoliodata,
      //         sipactiontaken,
      //         clientid,
      //         portfolioid,
      //         ISIN
      //       );

      //       setValue("goalNameSIP", portfoliodata.goal_name || ""); //need to improve
      //       setSelectedSipStartDate(); //need to improve
      //       setValue("sipAmountSIP", ""); //need to improve
      //       setValue("perpetualSIP", ""); //need to improve
      //       setSelectedSIPEndDate(); //need to improve
      //       break;

      //     case "Switch":
      //       if (sipactiontaken !== "Switch") return;
      //       console.log(
      //         "portfoliodata Switch:",
      //         portfoliodata,
      //         sipactiontaken,
      //         clientid,
      //         portfolioid,
      //         ISIN
      //       );

      //       // both are nessary set yes or no at same time
      //       setSwitchAllUnits(portfoliodata.allunites || "");
      //       setValue("allUnitsSwitch", portfoliodata.allunites || "");

      //       // any one is required to set value setAllUnits or setValue('allUnitsSwitch',portfoliodata.allunites || "")

      //       if (portfoliodata.allunites === "no") {
      //         setValue("transactionAmountSwitch", ""); //need to improve
      //         setValue("switchInFund", ""); //need to improve
      //         setSwitchInFund();
      //       }
      //       if (portfoliodata.allunites === "yes") {
      //         setValue("switchInFund", ""); //need to improve
      //         setSwitchInFund("");
      //         setValue("stpSwitch", ""); //need to improve
      //         if (portfoliodata.stpSwitch === "yes") {
      //           setValue("stpSwitchFrequency", ""); //need to improve
      //           setValue("stpSwitchDuration", ""); //need to improve
      //           setValue("stpSwitchlumpSumAmount", ""); //need to improve
      //           setSelectedStpSwitchStartDate(); //need to improve
      //         }
      //       }
      //       break;

      //     default:
      //       setSipAction("none");
      //       console.log("No matching action found");
      //       break;
      //   }

      //   // old is correct if above code not work
      //   // if (portfoliodata.action === "Redeem" && sipactiontaken === 'Redeem') {
      //   // console.log("portfoliodata Redeem:", portfoliodata, sipactiontaken, clientid, portfolioid, ISIN);

      //   //   setIsLabel(
      //   //     portfoliodata?.recommended_action?.replace(/<[^>]*>/g, "")
      //   //   );
      //   //   setSipAction("Redeem");
      //   //   setAllUnits(portfoliodata.allunites);
      //   //   // setValue("allUnitsRedeem", portfoliodata.allunites)

      //   //   if (portfoliodata.allunites === "no") {
      //   //     setValue("transactionAmountRedeem", portfoliodata.no_of_unites);
      //   //   } else {
      //   //     setReInvest(portfoliodata.is_reinvest);
      //   //     if (portfoliodata.is_reinvest === "yes") {
      //   //       setReInvestLumpsumamt(portfoliodata.reinvest_lumpsumamt);
      //   //       setValue("goalNameRedeem", portfoliodata.reinvest_fund);
      //   //       setValue("amcHouseRedeem", portfoliodata.reinvest_amc);
      //   //       setValue("fundNameRedeem", portfoliodata.reinvest_fund);
      //   //       setSTP(portfoliodata.is_stp);

      //   //       if (portfoliodata.is_stp === "yes") {
      //   //         setValue("stpInFund", portfoliodata.stp_fundname);
      //   //       }
      //   //     }
      //   //   }

      //   // }
      //   // else  if (portfoliodata.action === "STP" && sipactiontaken === "STP") {
      //   // console.log("portfoliodata STP:", portfoliodata, sipactiontaken, clientid, portfolioid, ISIN);
      //   // setIsLabel(
      //   //   portfoliodata?.recommended_action?.replace(/<[^>]*>/g, "")
      //   // );
      //   // setSipAction(portfoliodata.action);
      //   // setValue('frequencySTP','')               //need to set data from  portfoliodata
      //   // setValue('durationSTP','')                //need to set data from  portfoliodata
      //   // setValue('lumpSumAmountSTP','')           //need to set data from  portfoliodata
      //   // setValue('stpInFund','')                  //need to set data from  portfoliodata
      //   // setSelectedStpStartDate()                 //need to set setSelectedStpStartDate || startYear from  portfoliodata
      //   // setValue('stpInFund','')                  //need to set data from  portfoliodata

      //   // }
      //   // else  if (portfoliodata.action === "SIP" && sipactiontaken === "SIP"){
      //   // setValue('goalNameSIP','')               //need to set data from  portfoliodata

      //   // }

      //   // handlePortfolioAction(portfoliodata, sipactiontaken);
      //   setCheckedit(0);
      // }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    console.log("qq", preData);

    if (preData?.action !== "none") {
      // --------Action-----------
      setValue("sipaction", preData?.action);
      setSipAction(preData?.action);

      // -----------------Redeem-------------------
      setValue("allUnitsRedeem", preData?.allunites);
      // setAllUnits(preData?.allunites);
      setValue("reInvest", preData?.is_reinvest);
      // setReInvest(preData?.is_reinvest);
      setValue("goalNameRedeem", preData?.investing_goal);
      setValue("transactionAmountRedeem", preData?.no_of_unites);
      setValue("lumpSumAmountRedeem", preData?.reinvest_lumpsumamt);
      setValue("amcHouseRedeem", preData?.reinvest_amc);
      setValue("fundNameRedeem", preData?.reinvest_fund);
      setValue("redeem_stp", preData?.is_stp);
      // setShowSTP(preData?.is_stp);
      setValue("redeem_stp1", preData?.is_stp1);
      setValue("redeem_stp2", preData?.is_stp2);

      setValue("STP_Frequency", preData?.stp_frequency || "");
      setValue("STP_Frequency1", preData?.stp_frequency1 || "");
      setValue("STP_Frequency2", preData?.stp_frequency2 || "");
      setValue("stpDurationMonthRedeem", preData?.stp_duration);
      setValue("stpdurationmonth1", preData?.stp_duration1);
      setValue("stpdurationmonth2", preData?.stp_duration2);
      setValue("stplumpsumamount1", preData?.stp_lumpsum_amt);
      setValue("stplumpsumamount11", preData?.stp_lumpsum_amt1);
      setValue("stplumpsumamount12", preData?.stp_lumpsum_amt2);
      setValue("STP_fundName", preData?.stp_fundname);
      setValue("STP_fundName1", preData?.stp_fundname1);
      setValue("STP_fundName2", preData?.stp_fundname2);
      setValue("stpRedeemstartDate", preData?.stp_startdate);
      // setStpRedeemstartDate(preData?.stp_startdate);
      setStpRedeemstartDate_1(preData?.stp_startdate1);
      setStpRedeemstartDate_2(preData?.stp_startdate2);

      // ----------------- Switch ---------------
      setValue("allUnitsSwitch", preData?.allunites);
      // setAllUnits(preData?.allunites)
      setValue("transactionAmountSwitch", preData?.no_of_unites);
      // setValue("transactionAmountSwitch", Number(preData?.currentval).toFixed(0));

      setValue("stpSwitchFrequency", preData?.stp_frequency);
      setValue("switchInFund", preData?.switch_fund);
      // setSwitchInFund(preData?.switch_fund)
      setValue("stpSwitch", preData?.is_stp);

      setValue("stpSwitchDuration", preData?.stp_duration);
      setValue("stpSwitchlumpSumAmount", preData?.stp_lumpsum_amt);
      setValue("stpSwitchfundName", preData?.stp_fundname);
      setValue("stpStartDateSwitch", preData?.stp_startdate);
      // setSelectedStartDateSwitch(preData?.stp_startdate)

      // -----------------SIP-------------------
      // setValue(sip_startdate)
      // setSelectedStartDate(preData?.sip_startdate)
      setValue("sipStartDate", preData?.sip_startdate);
      setValue("sipAmountSIP", preData?.sip_restart_amt);
      setValue("perpetualSIP", preData?.is_sip_perpetual || "yes");
      setValue("sipEndDate", preData?.sip_enddate);
      // setIsPerpetualSIP(preData?.is_sip_perpetual)
      // setSelectedEndDate(preData?.sip_enddate)

      // -----------------STP-------------------
      setValue("frequencySTP", preData?.stp_frequency);
      setValue("durationSTP", preData?.stp_duration);
      setValue("lumpSumAmountSTP", preData?.stp_lumpsum_amt);
      setValue("stpInFund", preData?.stp_fundname);
      setValue("stpStartDate", preData?.stp_startdate);
      // setSelectedStartDateSTP(preData?.stp_startdate);
      // Select STP Start Date remain


      // -----------------Stop SIP-------------------
      setValue("startasip", preData?.is_restartasip);
      setValue("stopsip_amc", preData?.sip_amc);
      setValue("restartfundname", preData?.sip_fundname);
      // stop_sips
      // activesips

    } else {
      setValue("sipaction", "none");

    
    }
  }, [preData, isGoalResponse,]);


  // -----------------For  Switch ---------------
  const [isSTP1Enabled, setIsSTP1Enabled] = useState(false);
  const [isSTP2Enabled, setIsSTP2Enabled] = useState(false);
  const [isStpSwitchDisabled, setIsStpSwitchDisabled] = useState(false);



  useEffect(() => {
    if (allUnitsSwitchW === "yes") {
      const currentVal = Number(generateEiFormData?.currentval) || 0;
      const stp1 = Number(stpSwitchlumpSumAmountW) || 0;
      const stp2 = Number(stplumpsumamount1W1) || 0;
      
      // STP1: enable if currentVal > stp1
      setIsSTP1Enabled(currentVal > stp1);

      // STP2: enable if currentVal > (stp1 + stp2)
      setIsSTP2Enabled(currentVal > stp1 + stp2);
    } else if (allUnitsSwitchW === "no") {
      const currentVal = Number(generateEiFormData?.currentval) || 0;
      const stp1 =
        Number(stpSwitchlumpSumAmountW) + Number(transactionAmountSwitchW) || 0;
      const stp2 = Number(stplumpsumamount1W1) || 0;
      setIsSTP1Enabled(currentVal > stp1);

      setIsSTP2Enabled(currentVal > stp1 + stp2);
    }
  }, [generateEiFormData,allUnitsSwitchW, stpSwitchlumpSumAmountW,transactionAmountSwitchW, stplumpsumamount1W1]);

  useEffect(()=>{
    if (allUnitsSwitchW === "yes") {
      const currentVal = Number(generateEiFormData?.currentval) || 0;
      setValue("stpSwitchlumpSumAmount", currentVal);
    } else if (allUnitsSwitchW === "no") {
      // const currentVal = Number(generateEiFormData?.currentval) || 0;

      let currentVal
      if(preData?.no_of_unites!==null){
         currentVal = Number(preData?.no_of_unites);
      }else{
        currentVal = Number(generateEiFormData?.currentval) || 0;
      }
      setValue('transactionAmountSwitch',currentVal)
    }
  },[ActionW,allUnitsSwitchW])
 


  useEffect(() => {
    if (ActionW !== "Switch") return;
  
    const currentVal  = Number(generateEiFormData?.currentval) || 0;
    const enteredVal  = Number(transactionAmountSwitchW) || 0;
    const isPartial   = allUnitsSwitchW === "no";
  
    // ✅ default
    setValue("stpSwitch", "no");
  
    // ❌ invalid when partial & entered >= current
    if (isPartial && enteredVal >= currentVal) {
      setValue("stpSwitch", "no");
      setError("stpSwitch", {
        type: "manual",
        message: "Transaction amount must be less than current value",
      });
      setIsStpSwitchDisabled(true);
      setValue("stpSwitchlumpSumAmount", ""); // clear rest
      return;
    }
  
    // ✅ valid
    clearErrors("stpSwitch");
    setIsStpSwitchDisabled(false);
  
    if (isPartial && enteredVal > 0) {
      const restAmount = Math.max(currentVal - enteredVal, 0);
      // optional rounding: Number(restAmount.toFixed(2))
      setValue("stpSwitchlumpSumAmount", restAmount);
    } else if (allUnitsSwitchW === "yes") {
      // (optional) full switch -> rest = current
      setValue("stpSwitchlumpSumAmount", currentVal);
    } else {
      setValue("stpSwitchlumpSumAmount", "");
    }
  }, [
    ActionW,
    allUnitsSwitchW,
    transactionAmountSwitchW,
    generateEiFormData?.currentval,
    setValue,
    setError,
    clearErrors,
  ]);
  

   const fetchFunds = async () => {
    try {
      const fundHouse = selectedAmcHouse;
      const clientIdValue = isGenerateEIFormResponse?.body?.clientid;
      const portfolioIdValue = isGenerateEIFormResponse?.body?.portfolioid;
      const ISINValue = isGenerateEIFormResponse?.body?.ISIN;
      // Ensure the values you're passing are correct
      if (!clientIdValue || !portfolioIdValue || !ISINValue || !fundHouse) {
        throw new Error("Missing required parameters");
      }

      // Make the API request
      const response = await api.post(`advisor/amcfundEIlist`, {
        client_id: Number(clientIdValue),
        portfolio_id: String(portfolioIdValue),
        portfolio_isin: ISINValue,
        fundhouse: fundHouse,
      });

      // Check if response is successful
      if (response.data) {
        console.log("amcfundEIlist response data", response.data);
        setFundNameList(response.data);
      } else {
        console.error("No data received from API");
      }
    } catch (err) {
      console.error("Error fetching funds:", err.message || err);
    }
  };

  useEffect(() => {
    if (selectedAmcHouse) {
      fetchFunds();
    }
  }, [selectedAmcHouse]);

  const handleSipStartDateChange = (date) => {
    setSelectedSipStartDate(date);
  };
  const handleSIPEndDateChange = (date) => {
    setSelectedSIPEndDate(date);
  };
  const handleStpSwitchStartDateChange = (date) => {
    // setSelectedStpSwitchStartDate(date);
  };
  const handleStpStartDateChange = (date) => {
    // setSelectedStpStartDate(date);
  };

  const handleStartDateChange = (date) => {
    setSelectedStartDate(date);
  };

  const handelHideModal = () => {
    setCheckedit(0);
    onHide();
  };

  const handlegoalNameRedeemChange = (e) => {
    const selectedValue = e.target.value;
    if (!selectedValue) return;

    const [
      TargetAmount,
      goalId,
      goalName,
      accumulatedAmount,
      startyear,
      goalYear,
      expectedReturn,
      yearsRemain,
      monthlysaving,
      runningSIP,
    ] = selectedValue.split("|");

    setGoalDetails({
      TargetAmount,
      goalId,
      goalName,
      accumulatedAmount,
      startyear,
      goalYear,
      expectedReturn,
      yearsRemain,
      monthlysaving,
      runningSIP,
    });
  };

  return (
    <Modal
      show={show}
      onHide={handelHideModal}
      className="custom-sm-modal"
      centered
    >
      <Modal.Header
        closeButton
        className=""
        // style={{ backgroundColor: "", border: "none" }}
      >
        <Modal.Title>
          <p className="fs-6 fw-bold">
            {isGenerateEIFormResponse?.rowData?.schemeName}{" "}
            {isGenerateEIFormResponse?.rowData?.folio} Current value{" "}
            {isGenerateEIFormResponse?.rowData?.currentMktValue}
          </p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <div
          dangerouslySetInnerHTML={{
            __html: isGenerateEIFormResponse?.title || "Add Action Points",
          }}
          className="back-clrgreen text-white p-2 rounded-2 mb-2"
        /> */}

        <Form
          onSubmit={handleSubmit(onSubmit, (formErrors) => {
            console.log("⛔ Validation failed with errors:", formErrors);
          })}
        >
          {/* Section Header */}
          {/* <SectionHeader title={isLabel} /> */}
          <Modal.Title
            id="fundEditModal"
            style={{
              fontSize: "16px",
              backgroundColor: "#23674B",
              color: "#fff",
              marginBottom: 20,
              padding: "2px",
              borderRadius: "9999px",
              textAlign: "center", // Center align text
            }}
          >
            <div
              style={{ textAlign: "center" }} // Center align inner content
              className="px-4"
            >
              {actionName}
            </div>
          </Modal.Title>

          {/* action */}
          <Form.Group className="mb-3 mt-4">
            <Form.Label htmlFor="sipaction">Action</Form.Label>
            <Form.Select
              id="sipaction"
              {...register("sipaction", {
                required: "Please select an option for sipaction.",
              })}
              // value={sipAction}
              // onChange={(e) => setSipAction(e.target.value)}
            >
              <option value="">Select Action</option>
              <option value="none">No Action Required</option>
              <option value="Redeem">Redeem</option>
              <option value="Switch">Switch</option>
              <option value="STP">STP</option>
              <option value="SIP">SIP</option>
              {/* {clientreviewedfolioData?.portfolio_type_sip === 1 &&
                  preGoalName !== "Unmapped" && (
                    <option value="sip_stop">SIP Stop</option>
                  )} */}
            </Form.Select>
            {errors.sipaction && (
              <small className="text-danger">{errors.sipaction.message}</small>
            )}
          </Form.Group>
          {ActionW === "Redeem" && (
            <>
              {/* All Units */}
              <Form.Group className="mb-3">
                <Form.Label htmlFor="allUnits">All Units</Form.Label>
                <Form.Select
                  id="allUnits"
                  {...register("allUnitsRedeem", {
                    required: "This field is required.",
                  })}
                  // value={allUnits}
                  // onChange={(e) => {
                  //   setAllUnits(e.target.value);
                  //   setValue("allUnitsRedeem", e.target.value);
                  // }}
                >
                  <option value="">Select</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </Form.Select>
                {errors.allUnitsRedeem && (
                  <small className="text-danger">
                    {errors.allUnitsRedeem.message}
                  </small>
                )}
              </Form.Group>

              {allUnitsRedeemW === "no" && (
                <>
                  {/* Transaction Amount */}
                  <Form.Group className="mb-3">
                    <Form.Label htmlFor="transactionAmount">
                      Transaction Amount (Redeem Amount)
                    </Form.Label>
                    <Form.Control
                      type="number"
                      id="transactionAmount"
                      placeholder="Enter amount"
                      {...register("transactionAmountRedeem", {
                        required: "Transaction Amount is required.",
                        // min: {
                        //   value: 1,
                        //   message: "Amount must be at least 1.",
                        // },
                      })}
                    />
                    {errors.transactionAmountRedeem && (
                      <small className="text-danger">
                        {errors.transactionAmountRedeem.message}
                      </small>
                    )}
                  </Form.Group>
                </>
              )}

              {/* {allUnits === "yes" && ( */}
              <>
                {/* Re-Invest */}
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="reInvest">Re-Invest</Form.Label>
                  <Form.Select
                    id="reInvest"
                    {...register("reInvest", {
                      required: "Re-Invest is required.",
                    })}
                  >
                    <option value="">Select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </Form.Select>
                  {errors.reInvest && (
                    <small className="text-danger">
                      {errors.reInvest.message}
                    </small>
                  )}
                </Form.Group>

                {reInvestW === "yes" && (
                  <>
                    {/* Goal Name */}
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="goalNameRedeem">
                        Goal Name
                      </Form.Label>
                      <Form.Select
                        id="goalNameRedeem"
                        {...register("goalNameRedeem", {
                          required: "Goal Name is required.",
                        })}
                      >
                        {parsePortfolioOptions(
                          isEiPortfolio?.options?.options
                        ).map((option) => (
                          <>
                            <option key={option.id} value={option.name}>
                              {option.name}
                            </option>
                          </>
                        ))}
                      </Form.Select>

                      {errors.goalNameRedeem && (
                        <small className="text-danger">
                          {errors.goalNameRedeem.message}
                        </small>
                      )}
                    </Form.Group>

                    {/* Lump Sum Amount */}
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="lumpSumAmountRedeem">
                        Lump Sum Amount
                      </Form.Label>
                      <Form.Control
                        type="number"
                        id="lumpSumAmountRedeem"
                        placeholder="Enter amount"
                        {...register("lumpSumAmountRedeem", {
                          required: "Lump Sum Amount is required.",
                        })}
                      />
                      {errors.lumpSumAmountRedeem && (
                        <small className="text-danger">
                          {errors.lumpSumAmountRedeem.message}
                        </small>
                      )}
                    </Form.Group>

                    {/* AMC Name */}
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="amcName">AMC Name</Form.Label>
                      <Form.Select
                        id="amcHouse"
                        {...register("amcHouseRedeem", {
                          required: "AMC House is required.",
                        })}
                      >
                        <option value="">Select</option>
                        {/* Whitelisted Group */}
                        <optgroup label="Whitelisted">
                          {Object.values(generateEiFormData?.amchouselist)
                            ?.filter((item) => item.Whitelisted === "true")
                            .map((item, index) => (
                              <option key={index} value={item.fund_house_name}>
                                {item.fund_house_name}
                              </option>
                            ))}
                        </optgroup>

                        {/* Non-Whitelisted Group */}
                        <optgroup label="Non-Whitelisted">
                          {Object.values(generateEiFormData?.amchouselist)
                            ?.filter((item) => item.Whitelisted === "false")
                            .map((item, index) => (
                              <option key={index} value={item.fund_house_name}>
                                {item.fund_house_name}
                              </option>
                            ))}
                        </optgroup>
                      </Form.Select>
                      {errors.amcHouseRedeem && (
                        <small className="text-danger">
                          {errors.amcHouseRedeem.message}
                        </small>
                      )}
                    </Form.Group>

                    {/* Fund Name */}
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="fundName">Fund Name</Form.Label>
                      <Form.Select
                        id="fundName"
                        {...register("fundNameRedeem", {
                          required: "Fund Name is required.",
                        })}
                      >
                        <option value="">Select</option>
                        <>
                          <optgroup label="Whitelisted">
                            {amcNameList
                              .filter((item) => item?.Whitelisted === "true") // Check for string "true"
                              .map((item, index) => (
                                <option key={index} value={item?.fund_name}>
                                  {item?.fund_name}
                                </option>
                              ))}
                          </optgroup>

                          <optgroup label="Non-Whitelisted">
                            {amcNameList
                              .filter((item) => item?.Whitelisted === "false") // Check for string "false"
                              .map((item, index) => (
                                <option key={index} value={item?.fund_name}>
                                  {item?.fund_name}
                                </option>
                              ))}
                          </optgroup>
                        </>
                      </Form.Select>
                      {errors.fundNameRedeem && (
                        <small className="text-danger">
                          {errors.fundNameRedeem.message}
                        </small>
                      )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>+ STP ?</Form.Label>
                      <Form.Select
                        {...register("redeem_stp", {
                          required: "Please choose STP option.",
                        })}
                      >
                        <option value="">Select</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </Form.Select>
                      {errors.redeem_stp && (
                        <small className="text-danger">
                          {errors.redeem_stp.message}
                        </small>
                      )}
                    </Form.Group>

                    {redeem_stpW === "yes" && (
                      <>
                        <Form.Group className="mb-3">
                          <Form.Label>STP Frequency</Form.Label>
                          <Form.Select
                            {...register("STP_Frequency", {
                              required: "STP Frequency is required.",
                            })}
                          >
                            <option value="">Select</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Weekly">Weekly</option>
                          </Form.Select>
                          {errors.STP_Frequency && (
                            <small className="text-danger">
                              {errors.STP_Frequency.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>STP Duration</Form.Label>
                          <Form.Control
                            type="number"
                            {...register("stpDurationMonthRedeem", {
                              required: "STP Duration is required.",
                            })}
                          />
                          {errors.stpDurationMonthRedeem && (
                            <small className="text-danger">
                              {errors.stpDurationMonthRedeem.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Lump Sum1 </Form.Label>
                          <Form.Control
                            type="number"
                            {...register("stplumpsumamount1", {
                              required: "Lump Sum is required.",
                            })}
                          />
                          {errors.stplumpsumamount1 && (
                            <small className="text-danger">
                              {errors.stplumpsumamount1.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>STP In Fund </Form.Label>
                          <Form.Select
                            {...register("STP_fundName", {
                              required: "STP In Fund is required.",
                            })}
                          >
                            <option value="">Select</option>

                            <>
                              <optgroup label="Whitelisted">
                                {amcNameList
                                  .filter(
                                    (item) => item?.Whitelisted === "true"
                                  ) // Check for string "true"
                                  .map((item, index) => (
                                    <option
                                      key={index}
                                      value={item?.fund_name}
                                      disabled={
                                        item?.fund_name === fundNameRedeemW
                                      } 
                                    >
                                      {item?.fund_name}
                                    </option>
                                  ))}
                              </optgroup>

                              <optgroup label="Non-Whitelisted">
                                {amcNameList
                                  .filter(
                                    (item) => item?.Whitelisted === "false"
                                  ) // Check for string "false"
                                  .map((item, index) => (
                                    <option
                                      key={index}
                                      value={item?.fund_name}
                                      disabled={
                                        item?.fund_name === fundNameRedeemW
                                      }
                                    >
                                      {item?.fund_name}
                                    </option>
                                  ))}
                              </optgroup>
                            </>
                          </Form.Select>
                          {errors.STP_fundName && (
                            <small className="text-danger">
                              {errors.STP_fundName.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group
                          controlId="stpRedeemstartDate"
                          className="mb-3"
                        >
                          <Form.Label className="d-block">
                            STP Start Date
                          </Form.Label>
                          <Controller
                            name="stpRedeemstartDate"
                            control={control}
                            rules={{ required: "STP Start Date is required." }}
                            render={({ field }) => (
                              <DatePicker
                                className="form-control w-100 "
                                dateFormat="dd-MM-yyyy"
                                placeholderText="STP Start Date"
                                selected={field.value}
                                onChange={field.onChange}
                                minDate={new Date()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                              />
                            )}
                          />
                          {errors.stpRedeemstartDate && (
                            <small className="text-danger">
                              {errors.stpRedeemstartDate.message}
                            </small>
                          )}
                        </Form.Group>

                        {/* STP 2 Toggle */}

                        <Button
                          variant="outline-success"
                          type="button"
                          size="sm"
                          className="mb-2"
                          onClick={() => {
                            setValue("redeem_stp1", "yes");
                          }}
                        >
                          + STP?
                        </Button>

                        {/* STP 2 Fields */}
                        {redeem_stp1W === "yes" && (
                          <>
                            <Form.Group className="mb-3">
                              <Form.Label>STP Frequency </Form.Label>
                              <Form.Select {...register("STP_Frequency1")}>
                                <option value="">Select</option>
                                <option value="Monthly">Monthly</option>
                                <option value="Weekly">Weekly</option>
                              </Form.Select>
                              {errors.STP_Frequency1 && (
                                <small className="text-danger">
                                  {errors.STP_Frequency1.message}
                                </small>
                              )}
                            </Form.Group>

                            <Form.Group className="mb-3">
                              <Form.Label>STP Duration </Form.Label>
                              <Form.Control
                                type="number"
                                {...register("stpdurationmonth1")}
                              />
                              {errors.stpdurationmonth1 && (
                                <small className="text-danger">
                                  {errors.stpdurationmonth1.message}
                                </small>
                              )}
                            </Form.Group>

                            <Form.Group className="mb-3">
                              <Form.Label>Lump Sum </Form.Label>
                              <Form.Control
                                type="number"
                                {...register("stplumpsumamount11")}
                              />
                              {errors.stplumpsumamount11 && (
                                <small className="text-danger">
                                  {errors.stplumpsumamount11.message}
                                </small>
                              )}
                            </Form.Group>

                           
                            <Form.Group className="mb-3">
                                <Form.Label>STP In Fund </Form.Label>
                                <Form.Select
                                  {...register("STP_fundName1", {
                                    // required: "STP In Fund is required.",
                                    validate: (v) => {
                                      if (v === fundNameRedeemW)
                                        return "Cannot be same as Redeem Fund.";
                                      if (v === watch("STP_fundName"))
                                        return "Cannot be same as 1st STP Fund.";
                                      return true;
                                    },
                                  })}
                                >
                                  <option value="">Select</option>
                                  <>
                                    <optgroup label="Whitelisted">
                                      {amcNameList
                                        .filter(
                                          (item) => item?.Whitelisted === "true"
                                        )
                                        .map((item, index) => (
                                          <option
                                            key={index}
                                            value={item?.fund_name}
                                            disabled={
                                              item?.fund_name ===
                                                fundNameRedeemW ||
                                              item?.fund_name ===
                                                watch("STP_fundName") // disable if selected already
                                            }
                                          >
                                            {item?.fund_name}
                                          </option>
                                        ))}
                                    </optgroup>

                                    <optgroup label="Non-Whitelisted">
                                      {amcNameList
                                        .filter(
                                          (item) =>
                                            item?.Whitelisted === "false"
                                        )
                                        .map((item, index) => (
                                          <option
                                            key={index}
                                            value={item?.fund_name}
                                            disabled={
                                              item?.fund_name ===
                                                fundNameRedeemW ||
                                              item?.fund_name ===
                                                watch("STP_fundName")
                                            }
                                          >
                                            {item?.fund_name}
                                          </option>
                                        ))}
                                    </optgroup>
                                  </>
                                </Form.Select>
                                {errors.STP_fundName1 && (
                                  <small className="text-danger">
                                    {errors.STP_fundName1.message}
                                  </small>
                                )}
                              </Form.Group>

                            <Form.Group className="mb-3">
                              <Form.Label>Start Date </Form.Label>
                              <DatePicker
                                className="form-control"
                                selected={stpRedeemstartDate1}
                                onChange={handleRedeemStartDateChange1}
                                minDate={new Date()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                              />
                            </Form.Group>

                            {/* Cancel STP2 */}
                            <Button
                              variant="outline-danger"
                              type="button"
                              className="me-2 mb-2"
                              size="sm"
                              onClick={resetSTP2Fields}
                            >
                              Cancel STP
                            </Button>

                            {/* STP3 Toggle */}
                            {redeem_stp2W !== "yes" && (
                              <Button
                                variant="outline-success"
                                type="button"
                                size="sm"
                                className="mb-2"
                                onClick={(e) => {
                                  setValue("redeem_stp2", "yes");
                                }}
                              >
                                + STP?
                              </Button>
                            )}
                          </>
                        )}

                        {/* STP 3 Fields */}
                        {redeem_stp2W === "yes" && (
                          <>
                            <Form.Group className="mb-3">
                              <Form.Label>STP Frequency</Form.Label>
                              <Form.Select {...register("STP_Frequency2")}>
                                <option value="">Select</option>
                                <option value="Monthly">Monthly</option>
                                <option value="Weekly">Weekly</option>
                              </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3">
                              <Form.Label>STP Duration </Form.Label>
                              <Form.Control
                                type="number"
                                {...register("stpdurationmonth2")}
                              />
                              {errors.stpdurationmonth2 && (
                                <small className="text-danger">
                                  {errors.stpdurationmonth2.message}
                                </small>
                              )}
                            </Form.Group>

                            <Form.Group className="mb-3">
                              <Form.Label>Lump Sum</Form.Label>
                              <Form.Control
                                type="number"
                                {...register("stplumpsumamount12")}
                              />
                              {errors.stplumpsumamount12 && (
                                <small className="text-danger">
                                  {errors.stplumpsumamount12.message}
                                </small>
                              )}
                            </Form.Group>

                            <Form.Group className="mb-3">
                              <Form.Label>STP In Fund</Form.Label>
                            
                              <Form.Select {...register("STP_fundName2", {
                                    // required: "STP In Fund is required.",
                                    validate: (v) => {
                                      if (v === fundNameRedeemW)
                                        return "Cannot be same as Redeem Fund.";
                                      if (v === watch("STP_fundName"))
                                        return "Cannot be same as 1st STP Fund.";
                                      if (v === watch("STP_fundName1"))
                                        return "Cannot be same as 2nd STP Fund.";
                                      return true;
                                    },
                                  })}>
                                <option value="">Select</option>
                                {/* {console.log("fundNameList", fundNameList,amcNameList)} */}
                                <>
                                  <optgroup label="Whitelisted">
                                    {amcNameList
                                      .filter(
                                        (item) => item?.Whitelisted === "true"
                                      ) // Check for string "true"
                                      .map((item, index) => (
                                        <option
                                          key={index}
                                          value={item?.fund_name}
                                          disabled={
                                            item?.fund_name ===
                                              fundNameRedeemW ||
                                            item?.fund_name ===
                                              watch("STP_fundName")||
                                              item?.fund_name ===
                                              watch("STP_fundName1")
                                          }
                                        >
                                          {item?.fund_name}
                                        </option>
                                      ))}
                                  </optgroup>

                                  <optgroup label="Non-Whitelisted">
                                    {amcNameList
                                      .filter(
                                        (item) => item?.Whitelisted === "false"
                                      ) // Check for string "false"
                                      .map((item, index) => (
                                        <option
                                          key={index}
                                          value={item?.fund_name}
                                          disabled={
                                            item?.fund_name ===
                                              fundNameRedeemW ||
                                            item?.fund_name ===
                                              watch("STP_fundName")||
                                              item?.fund_name ===
                                              watch("STP_fundName1")
                                          }
                                        >
                                          {item?.fund_name}
                                        </option>
                                      ))}
                                  </optgroup>
                                </>
                              </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3">
                              <Form.Label>Start Date </Form.Label>
                              <DatePicker
                                className="form-control"
                                selected={stpRedeemstartDate2}
                                onChange={handleRedeemStartDateChange2}
                                minDate={new Date()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                              />
                            </Form.Group>
                            <Button
                              variant="outline-danger"
                              type="button"
                              className="my-2"
                              size="sm"
                              onClick={resetSTP3Fields}
                            >
                              Cancel STP
                            </Button>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
              {/* )} */}
            </>
          )}

{ActionW === "Switch" && (
              <>
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="allUnitsSwitch">All Units</Form.Label>
                  <Form.Select
                    id="allUnits"
                    {...register("allUnitsSwitch", {
                      required: "This field is required.",
                    })}
                    // value={allUnits}
                    // onChange={(e) => {
                    //   setAllUnits(e.target.value);
                    //   setValue("allUnitsSwitch", e.target.value);
                    // }}
                  >
                    <option value="">Select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </Form.Select>
                  {errors.allUnitsSwitch && (
                    <small className="text-danger">
                      {errors.allUnitsSwitch.message}
                    </small>
                  )}
                </Form.Group>

                {allUnitsSwitchW === "no" && (
                  <Form.Group className="mb-3">
                    <Form.Label htmlFor="transactionAmountSwitch">
                      Transaction Amount (Switch Amount)
                    </Form.Label>
                    <Form.Control
                      type="number"
                      id="transactionAmountSwitch"
                      placeholder="Enter amount"
                      {...register("transactionAmountSwitch", {
                        required: "Transaction Amount is required.",
                      })}
                    />
                    {errors.transactionAmountSwitch && (
                      <small className="text-danger">
                        {errors.transactionAmountSwitch.message}
                      </small>
                    )}
                  </Form.Group>
                )}

                {(allUnitsSwitchW === "yes" || allUnitsSwitchW === "no") &&
                  ActionW === "Switch" && (
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="switchInFund">
                        Select Switch In Fund
                      </Form.Label>
                      <Form.Select
                        id="switchInFund"
                        {...register("switchInFund", {
                          required: "Switch In Fund is required.",
                        })}
                      >
                        <option value="">Select</option>
                        <>
                          <optgroup label="Whitelisted">
                            {generateEiFormData?.switchfundlist
                              ?.filter((item) => item?.Whitelisted === "true") // Check for string "true"
                              ?.map((item, index) => (
                                <option key={index} value={item?.fund_name}>
                                  {item?.fund_name}
                                </option>
                              ))}
                          </optgroup>

                          <optgroup label="Non-Whitelisted">
                            {generateEiFormData?.switchfundlist
                              ?.filter((item) => item?.Whitelisted === "false") // Check for string "false"
                              ?.map((item, index) => (
                                <option key={index} value={item?.fund_name}>
                                  {item?.fund_name}
                                </option>
                              ))}
                          </optgroup>
                        </>
                      </Form.Select>
                      {errors.switchInFund && (
                        <small className="text-danger">
                          {errors.switchInFund.message}
                        </small>
                      )}
                    </Form.Group>
                  )}

                {(allUnitsSwitchW === "yes" || allUnitsSwitchW === "no") &&
                  ActionW === "Switch" &&
                  switchInFundW !== null && (
                    <>
                      {/* stp */}
                      <Form.Group className="mb-3">
                        <Form.Label htmlFor="stp">+ STP?</Form.Label>
                        <Form.Select
                          id="stp"
                          {...register("stpSwitch", {
                            required:
                              "Please specify if you want to re-invest.",
                          })}
                          onChange={(e) => {
                            setValue("stpSwitch", e.target.value); // Update react-hook-form value
                          }}
                          disabled={isStpSwitchDisabled}

                        >
                          <option value="">Select</option>
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                        </Form.Select>
                        {errors.stpSwitch && (
                          <small className="text-danger">
                            {errors.stpSwitch.message}
                          </small>
                        )}
                      </Form.Group>
                    </>
                  )}

                {stpSwitchW === "yes" && (
                  <>
                    {/* STP Frequency */}
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="stp">STP Frequency</Form.Label>
                      <Form.Select
                        id="stpFrequency"
                        {...register("stpSwitchFrequency", {
                          required: "STP Frequency is required.",
                        })}
                      >
                        <option value="">Select</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Weekly">Weekly</option>
                      </Form.Select>
                      {errors.stpSwitchFrequency && (
                        <small className="text-danger">
                          {errors.stpSwitchFrequency.message}
                        </small>
                      )}
                    </Form.Group>

                    {/* STP Duration (Months) */}
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="stpSwitchDuration">
                        STP Duration (Months)
                      </Form.Label>

                      <Form.Control
                        type="number"
                        id="stpSwitchDuration"
                        placeholder="Enter duration"
                        {...register("stpSwitchDuration", {
                          required: "Duration is required.",
                        })}
                      />
                      {errors.stpSwitchDuration && (
                        <small className="text-danger">
                          {errors.stpSwitchDuration.message}
                        </small>
                      )}
                    </Form.Group>

                    {/* STP Lump Sum Amount */}
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="stplumpSumAmount">
                        Lump Sum Amount
                      </Form.Label>
                      <Form.Control
                        type="number"
                        id="stplumpSumAmount"
                        placeholder="Enter amount"
                        {...register("stpSwitchlumpSumAmount", {
                          required: "Lump Sum Amount is required.",
                          min: {
                            value: 1,
                            message: "Amount must be at least 1.",
                          },
                        })}
                      />
                      {errors.stpSwitchlumpSumAmount && (
                        <small className="text-danger">
                          {errors.stpSwitchlumpSumAmount.message}
                        </small>
                      )}
                    </Form.Group>

                    {/* STP Switch fundName */}
                    {/* <Form.Group className="mb-3">
                      <Form.Label>STP In Fund </Form.Label>
                      <Form.Select
                        {...register("stpSwitchfundName", {
                          required: "STP Fund is required.",
                        })}
                      >
                        <option value="">Select</option>
                        <>
                          <optgroup label="Whitelisted">
                            {generateSipForm?.switchfundlist
                              ?.filter((item) => item?.Whitelisted === "true") // Check for string "true"
                              .map((item, index) => (
                                <option key={index} value={item?.fund_name}>
                                  {item?.fund_name}
                                </option>
                              ))}
                          </optgroup>

                          <optgroup label="Non-Whitelisted">
                            {generateSipForm?.switchfundlist
                              ?.filter((item) => item?.Whitelisted === "false") // Check for string "false"
                              .map((item, index) => (
                                <option key={index} value={item?.fund_name}>
                                  {item?.fund_name}
                                </option>
                              ))}
                          </optgroup>
                        </>
                      </Form.Select>
                      {errors.stpSwitchfundName && (
                        <small className="text-danger">
                          {errors.stpSwitchfundName.message}
                        </small>
                      )}
                    </Form.Group> */}

                    <Form.Group className="mb-3">
                      <Form.Label>STP In Fund</Form.Label>
                      <Form.Select
                        {...register("stpSwitchfundName", {
                          required: "STP Fund is required.",
                          validate: (v) =>
                            v === watch("switchInFund")
                              ? "STP Fund cannot be the same as Switch In Fund."
                              : true,
                        })}
                      >
                        <option value="">Select</option>
                        <>
                          <optgroup label="Whitelisted">
                            {generateEiFormData?.switchfundlist
                              ?.filter((item) => item?.Whitelisted === "true")
                              .map((item, index) => (
                                <option
                                  key={index}
                                  value={item?.fund_name}
                                  disabled={
                                    item?.fund_name === watch("switchInFund")
                                  }
                                >
                                  {item?.fund_name}
                                </option>
                              ))}
                          </optgroup>

                          <optgroup label="Non-Whitelisted">
                            {generateEiFormData?.switchfundlist
                              ?.filter((item) => item?.Whitelisted === "false")
                              .map((item, index) => (
                                <option
                                  key={index}
                                  value={item?.fund_name}
                                  disabled={
                                    item?.fund_name === watch("switchInFund")
                                  }
                                >
                                  {item?.fund_name}
                                </option>
                              ))}
                          </optgroup>
                        </>
                      </Form.Select>

                      {errors.stpSwitchfundName && (
                        <small className="text-danger">
                          {errors.stpSwitchfundName.message}
                        </small>
                      )}
                    </Form.Group>

                    {/* STP Start Date */}
                    <Form.Group controlId="stpStartDate" className="mb-3">
                      <Form.Label className="d-block">
                        Select STP Start Date
                      </Form.Label>
                      <Controller
                        name="stpStartDateSwitch"
                        control={control}
                        rules={{ required: "STP Start Date is required." }}
                        render={({ field }) => (
                          <DatePicker
                            className="form-control w-100 "
                            dateFormat="dd-MM-yyyy"
                            placeholderText="STP Start Date"
                            selected={field.value}
                            onChange={field.onChange}
                            minDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                          />
                        )}
                      />
                      {errors.stpStartDateSwitch && (
                        <small className="text-danger">
                          {errors.stpStartDateSwitch.message}
                        </small>
                      )}
                    </Form.Group>


                    {/* STP1 Button */}
                    {redeem_stp1W !== "yes" && (
                      <Button
                        variant="outline-success"
                        type="button"
                        size="sm"
                        className="mb-2 me-2"
                        disabled={!isSTP1Enabled}
                        onClick={() => {
                          setValue("redeem_stp1", "yes");
                        }}
                      >
                        + STP?
                      </Button>
                    )}

                    {/* STP 2 Fields */}
                    {redeem_stp1W === "yes" && (
                      <>
                        <Form.Group className="mb-3">
                          <Form.Label>STP Frequency </Form.Label>
                          <Form.Select {...register("STP_Frequency1")}>
                            <option value="">Select</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Weekly">Weekly</option>
                          </Form.Select>
                          {errors.STP_Frequency1 && (
                            <small className="text-danger">
                              {errors.STP_Frequency1.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>STP Duration </Form.Label>
                          <Form.Control
                            type="number"
                            {...register("stpdurationmonth1")}
                          />
                          {errors.stpdurationmonth1 && (
                            <small className="text-danger">
                              {errors.stpdurationmonth1.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Lump Sum1</Form.Label>
                          <Form.Control
                            type="number"
                            {...register("stplumpsumamount11")}
                          />
                          {errors.stplumpsumamount11 && (
                            <small className="text-danger">
                              {errors.stplumpsumamount11.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>STP In Fund</Form.Label>
                          <Form.Select
                            {...register("STP_fundName1", {
                              // required: "STP In Fund is required.",
                              validate: (v) => {
                                if (v === watch("stpSwitchfundName"))
                                  return "Cannot be same as STP Switch Fund.";
                                if (v === watch("switchInFund"))
                                  return "Cannot be same as Switch In Fund.";
                                return true;
                              },
                            })}
                          >
                            <option value="">Select</option>

                            <>
                              <optgroup label="Whitelisted">
                                {generateEiFormData?.switchfundlist
                                  .filter(
                                    (item) => item?.Whitelisted === "true"
                                  )
                                  .map((item, index) => {
                                    const isDisabled =
                                      item?.fund_name ===
                                        watch("stpSwitchfundName") ||
                                      item?.fund_name === watch("switchInFund");
                                    return (
                                      <option
                                        key={index}
                                        value={item?.fund_name}
                                        disabled={isDisabled}
                                      >
                                        {item?.fund_name}
                                      </option>
                                    );
                                  })}
                              </optgroup>

                              <optgroup label="Non-Whitelisted">
                                {generateEiFormData?.switchfundlist
                                  .filter(
                                    (item) => item?.Whitelisted === "false"
                                  )
                                  .map((item, index) => {
                                    const isDisabled =
                                      item?.fund_name ===
                                        watch("stpSwitchfundName") ||
                                      item?.fund_name === watch("switchInFund");
                                    return (
                                      <option
                                        key={index}
                                        value={item?.fund_name}
                                        disabled={isDisabled}
                                      >
                                        {item?.fund_name}
                                      </option>
                                    );
                                  })}
                              </optgroup>
                            </>
                          </Form.Select>

                          {errors.STP_fundName1 && (
                            <small className="text-danger">
                              {errors.STP_fundName1.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Start Date </Form.Label>
                          <DatePicker
                            className="form-control"
                            selected={stpRedeemstartDate1}
                            onChange={handleRedeemStartDateChange1}
                            minDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                          />
                        </Form.Group>

                        {/* Cancel STP2 */}
                        <Button
                          variant="outline-danger"
                          type="button"
                          className="me-2 mb-2"
                          size="sm"
                          onClick={resetSTP2Fields}
                        >
                          Cancel STP
                        </Button>

                        {/* STP3 Toggle */}
                        {/* STP2 Button */}
                        {redeem_stp2W !== "yes" && (
                          <Button
                            variant="outline-success"
                            type="button"
                            size="sm"
                            className="mb-2"
                            disabled={!isSTP2Enabled}
                            onClick={() => {
                              setValue("redeem_stp2", "yes");
                            }}
                          >
                            + STP?
                          </Button>
                        )}
                      </>
                    )}

                    {/* STP 3 Fields */}
                    {redeem_stp2W === "yes" && (
                      <>
                        <Form.Group className="mb-3">
                          <Form.Label>STP Frequency</Form.Label>
                          <Form.Select {...register("STP_Frequency2")}>
                            <option value="">Select</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Weekly">Weekly</option>
                          </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>STP Duration </Form.Label>
                          <Form.Control
                            type="number"
                            {...register("stpdurationmonth2")}
                          />
                          {errors.stpdurationmonth2 && (
                            <small className="text-danger">
                              {errors.stpdurationmonth2.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Lump Sum</Form.Label>
                          <Form.Control
                            type="number"
                            {...register("stplumpsumamount12")}
                          />
                          {errors.stplumpsumamount12 && (
                            <small className="text-danger">
                              {errors.stplumpsumamount12.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>STP In Fund</Form.Label>
                          <Form.Select
                            {...register("STP_fundName2", {
                              // required: "STP In Fund is required.",
                              validate: (v) => {
                                if (v === watch("switchInFund"))
                                  return "Cannot be same as Switch In Fund.";
                                if (v === watch("stpSwitchfundName"))
                                  return "Cannot be same as STP Switch Fund.";
                                if (v === watch("STP_fundName1"))
                                  return "Cannot be same as STP In Fund 1.";
                                return true;
                              },
                            })}
                          >
                            <option value="">Select</option>
                            <>
                              <optgroup label="Whitelisted">
                                {generateEiFormData?.switchfundlist
                                  .filter(
                                    (item) => item?.Whitelisted === "true"
                                  )
                                  .map((item, index) => {
                                    const isDisabled =
                                      item?.fund_name ===
                                        watch("switchInFund") ||
                                      item?.fund_name ===
                                        watch("stpSwitchfundName") ||
                                      item?.fund_name ===
                                        watch("STP_fundName1");

                                    return (
                                      <option
                                        key={index}
                                        value={item?.fund_name}
                                        disabled={isDisabled}
                                      >
                                        {item?.fund_name}
                                      </option>
                                    );
                                  })}
                              </optgroup>

                              <optgroup label="Non-Whitelisted">
                                {generateEiFormData?.switchfundlist
                                  .filter(
                                    (item) => item?.Whitelisted === "false"
                                  )
                                  .map((item, index) => {
                                    const isDisabled =
                                      item?.fund_name ===
                                        watch("switchInFund") ||
                                      item?.fund_name ===
                                        watch("stpSwitchfundName") ||
                                      item?.fund_name ===
                                        watch("STP_fundName1");

                                    return (
                                      <option
                                        key={index}
                                        value={item?.fund_name}
                                        disabled={isDisabled}
                                      >
                                        {item?.fund_name}
                                      </option>
                                    );
                                  })}
                              </optgroup>
                            </>
                          </Form.Select>

                          {errors.STP_fundName2 && (
                            <small className="text-danger">
                              {errors.STP_fundName2.message}
                            </small>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Start Date </Form.Label>
                          <DatePicker
                            className="form-control"
                            selected={stpRedeemstartDate2}
                            onChange={handleRedeemStartDateChange2}
                            minDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                          />
                        </Form.Group>
                        <Button
                          variant="outline-danger"
                          type="button"
                          className="my-2"
                          size="sm"
                          onClick={resetSTP3Fields}
                        >
                          Cancel STP
                        </Button>
                      </>
                    )}
                  </>
                )}
              </>
            )}

          {ActionW === "STP" && (
            <>
              {/* STP Frequency */}
              <Form.Group className="mb-3">
                <Form.Label htmlFor="stp">STP Frequency</Form.Label>
                <Form.Select
                  id="stpFrequency"
                  {...register("frequencySTP", {
                    required: "STP Frequency required.",
                  })}
                >
                  <option value="">Select</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Weekly">Weekly</option>
                </Form.Select>
                {errors.frequencySTP && (
                  <small className="text-danger">
                    {errors.frequencySTP.message}
                  </small>
                )}
              </Form.Group>

              {/* STP Duration (Months) */}
              <Form.Group className="mb-3">
                <Form.Label htmlFor="transactionAmount">
                  STP Duration (Months)
                </Form.Label>

                <Form.Control
                  type="number"
                  id="stpDuration"
                  placeholder="Enter amount"
                  {...register("durationSTP", {
                    required: "Duration is required.",
                    min: { value: 1, message: "Amount must be at least 1." },
                  })}
                />
                {errors.durationSTP && (
                  <small className="text-danger">
                    {errors.durationSTP.message}
                  </small>
                )}
              </Form.Group>
              {/* Lump Sum Amount */}
              <Form.Group className="mb-3">
                <Form.Label htmlFor="lumpSumAmountSTP">
                  Lump Sum Amountt
                </Form.Label>
                <Form.Control
                  type="number"
                  id="lumpSumAmountSTP"
                  placeholder="Enter amount"
                  {...register("lumpSumAmountSTP", {
                    required: "Lump Sum Amount is required.",
                    // min: {
                    //   value: 1,
                    //   message: "Amount must be at least 1.",
                    // },
                  })}
                />
                {errors.lumpSumAmountSTP && (
                  <small className="text-danger">
                    {errors.lumpSumAmountSTP.message}
                  </small>
                )}
              </Form.Group>

              {/* Select STP In Fund */}
              <Form.Group className="mb-3">
                <Form.Label htmlFor="stpInFund">Select STP In Fund</Form.Label>
                <Form.Select
                  id="stpInFund"
                  // value={isSwitchInFund}
                  {...register("stpInFund", {
                    required: "Stp In Fund is required.",
                  })}
                  // onChange={(e) => {
                  //   // setSwitchInFund(e.target.value);
                  //   setValue("stpInFund", e.target.value);
                  // }}
                >
                  <option value="">Select</option>
                  <>
                    <optgroup label="Whitelisted">
                      {generateEiFormData?.switchfundlist
                        .filter((item) => item?.Whitelisted === "true") // Check for string "true"
                        .map((item, index) => (
                          <option key={index} value={item?.fund_name}>
                            {item?.fund_name}
                          </option>
                        ))}
                    </optgroup>

                    <optgroup label="Non-Whitelisted">
                      {generateEiFormData?.switchfundlist
                        .filter((item) => item?.Whitelisted === "false") // Check for string "false"
                        .map((item, index) => (
                          <option key={index} value={item?.fund_name}>
                            {item?.fund_name}
                          </option>
                        ))}
                    </optgroup>
                  </>
                </Form.Select>
                {errors.stpInFund && (
                  <small className="text-danger">
                    {errors.stpInFund.message}
                  </small>
                )}
              </Form.Group>

              {/* STP Start Date */}
              <Form.Group controlId="stpStartDate" className="mb-3">
                <Form.Label className="d-block">
                  Select STP Start Date
                </Form.Label>
                <Controller
                  name="stpStartDate"
                  control={control}
                  rules={{ required: "STP Start Date is required." }}
                  render={({ field }) => (
                    <DatePicker
                      className="form-control w-100 "
                      dateFormat="dd-MM-yyyy"
                      placeholderText="STP Start Date"
                      selected={field.value}
                      onChange={field.onChange}
                      minDate={new Date()}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                  )}
                />
                {errors.stpStartDate && (
                  <small className="text-danger">
                    {errors.stpStartDate.message}
                  </small>
                )}
              </Form.Group>
            </>
          )}

          {ActionW === "SIP" && (
            <>
              {/* Goal Name */}
              <Form.Group className="mb-3">
                <Form.Label htmlFor="goalNameSIP">Goal Name</Form.Label>
                <Form.Control
                  id="goalNameSIP"
                  type="text"
                  readOnly
                  {...register("goalNameSIP", {
                    required: "Goal Name is required.",
                  })}
                  // dangerouslySetInnerHTML={{
                  //   __html: isPortfolioData.options.options,
                  // }}
                ></Form.Control>
                {errors.goalNameSIP && (
                  <small className="text-danger">
                    {errors.goalNameSIP.message}
                  </small>
                )}
              </Form.Group>

              {/* SIP Start Date */}
              <Form.Group controlId="sipStartDate" className="mb-3">
                <Form.Label className="d-block">SIP Start Date</Form.Label>
                <Controller
                  name="sipStartDate"
                  control={control}
                  rules={{ required: "SIP Start Date is required." }}
                  render={({ field }) => (
                    <DatePicker
                      className="form-control w-100 "
                      dateFormat="dd-MM-yyyy"
                      placeholderText="SIP Start Date"
                      selected={field.value}
                      onChange={field.onChange}
                      minDate={new Date()}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                  )}
                />
                {errors.sipStartDate && (
                  <small className="text-danger">
                    {errors.sipStartDate.message}
                  </small>
                )}
              </Form.Group>

              {/* Sip Amount */}
              <Form.Group className="mb-3">
                <Form.Label htmlFor="sipAmount">SIP Amount</Form.Label>

                <Form.Control
                  type="number"
                  id="sipAmount"
                  placeholder="Enter SIP Amount"
                  {...register("sipAmountSIP", {
                    required: "Sip Amountis required.",
                    min: { value: 1, message: "Amount must be at least 1." },
                  })}
                />
                {errors.sipAmountSIP && (
                  <small className="text-danger">
                    {errors.sipAmountSIP.message}
                  </small>
                )}
              </Form.Group>

              {/* Perpetual SIP */}
              <Form.Group className="mb-3">
                <Form.Label htmlFor="perpetualSIP">Perpetual SIP?</Form.Label>
                <Form.Select
                  id="perpetualSIP"
                  {...register("perpetualSIP", {
                    required: "Perpetual SIP required",
                  })}
                  // value={isPerpetualSIP}
                  // onChange={(e) => {
                  //   setIsPerpetualSIP(e.target.value);
                  //   setValue("perpetualSIP", e.target.value); // Update react-hook-form value
                  // }}
                >
                  <option value="">Select</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </Form.Select>
                {errors.perpetualSIP && (
                  <small className="text-danger">
                    {errors.perpetualSIP.message}
                  </small>
                )}
              </Form.Group>

              {perpetualSIPW === "no" && (
                <>
                  {/* SIP End Date */}
                  <Form.Group controlId="sipEndDate" className="mb-3">
                    <Form.Label className="d-block">SIP End Date</Form.Label>
                    <Controller
                      name="sipEndDate"
                      control={control}
                      rules={{ required: "SIP End Date is required." }}
                      render={({ field }) => (
                        <DatePicker
                          className="form-control w-100 "
                          dateFormat="dd-MM-yyyy"
                          placeholderText="SIP End Date"
                          selected={field.value}
                          onChange={field.onChange}
                          minDate={new Date()}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                        />
                      )}
                    />
                    {errors.sipEndDate && (
                      <small className="text-danger">
                        {errors.sipEndDate.message}
                      </small>
                    )}
                  </Form.Group>
                </>
              )}
            </>
          )}

          {/* ---------SIP Stop-------- */}
          {ActionW === "sip_stop" && (
            <>
              {/* Active SIPs list (checkboxes) */}
              {/* {Array.isArray(activeSips) && activeSips.length > 0 ? (
                  <div className="mb-3">
                    <div className="row fw-bold px-2">
                      <div className="col-md-2">Mode</div>
                      <div className="col-md-2">Amt</div>
                      <div className="col-md-3">ECS Date</div>
                      <div className="col-md-4">Bank Details</div>
                      <div className="col-md-1">Stop?</div>
                    </div>
                    {activeSips.map((s) => {
                      const last4 =
                        (s?.sip_bank_account || "").slice(
                          Math.max(0, (s?.sip_bank_account || "").length - 4)
                        ) || "";
                      const disabled =
                        String(s?.type).toLowerCase() !== "online";
                      // console.log('ss',s);
                   console.log("isLable",generateSipForm?.sipdata, stopSipSelection, activeSips);

                      return (
                        <div
                          className="row align-items-center px-2 py-1"
                          key={s._id}
                        >
                          <div className="col-md-2">{s?.type}</div>
                          <div className="col-md-2">{s?.sip_amount}</div>
                          <div className="col-md-3">
                            {s?.sip_startdata
                              ? new Date(s.sip_startdata).toLocaleString(
                                  "en-GB",
                                  {
                                    day: "numeric",
                                  }
                                ) + " (ECS)"
                              : "-"}
                          </div>
                          <div className="col-md-4">
                            {(s?.sip_bank_name || "").slice(0, 10)} / {last4}
                          </div>
                          <div className="col-md-1">
                            <Form.Check
                              type="checkbox"
                              disabled={disabled}
                              checked={!!stopSipSelection[s._id]}
                              onChange={(e) =>
                                toggleStopSip(s._id, e.target.checked)
                              }
                            />
                          </div>
                        </div>
                      );
                    })}
                    {Object.values(stopSipSelection).some(Boolean) ? null : (
                      <small className="text-danger">
                        Select at least one online SIP to stop.
                      </small>
                    )}
                  </div>
                ) : (
                  <p className="text-muted">No active SIPs found.</p>
                )} */}
              {stopSipSelection &&
                Object.values(stopSipSelection).some(Boolean) && (
                  <>
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="startasip">
                        Re-start a SIP?
                      </Form.Label>
                      <Form.Select
                        id="startasip"
                        {...register("startasip", {
                          required: "Re-start a SIP is required.",
                        })}
                      >
                        <option value="">Select</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </Form.Select>
                      {errors.startasip && (
                        <small className="text-danger">
                          {errors.startasip.message}
                        </small>
                      )}
                    </Form.Group>
                    {startasipW && startasipW === "yes" && (
                      <>
                        {/* AMC Name */}
                        <Form.Group className="mb-3">
                          <Form.Label htmlFor="amcName">AMC Name</Form.Label>
                          <Form.Select
                            id="amcHouse"
                            {...register("stopsip_amc", {
                              required: "AMC House is required.",
                            })}
                          >
                            <option value="">Select</option>
                            {/* Whitelisted Group */}
                            <optgroup label="Whitelisted">
                              {Object.values(generateEiFormData?.amchouselist)
                                ?.filter((item) => item.Whitelisted === "true")
                                .map((item, index) => (
                                  <option
                                    key={index}
                                    value={item.fund_house_name}
                                  >
                                    {item.fund_house_name}
                                  </option>
                                ))}
                            </optgroup>

                            {/* Non-Whitelisted Group */}
                            <optgroup label="Non-Whitelisted">
                              {Object.values(generateEiFormData?.amchouselist)
                                ?.filter((item) => item.Whitelisted === "false")
                                .map((item, index) => (
                                  <option
                                    key={index}
                                    value={item.fund_house_name}
                                  >
                                    {item.fund_house_name}
                                  </option>
                                ))}
                            </optgroup>
                          </Form.Select>
                          {errors.stopsip_amc && (
                            <small className="text-danger">
                              {errors.stopsip_amc.message}
                            </small>
                          )}
                        </Form.Group>

                        {/* Fund Name */}
                        <Form.Group className="mb-3">
                          <Form.Label htmlFor="fundName">Fund Name</Form.Label>
                          <Form.Select
                            id="fundName"
                            {...register("restartfundname", {
                              required: "Fund Name is required.",
                            })}
                          >
                            <option value="">Select</option>
                            <>
                              <optgroup label="Whitelisted">
                                {amcNameList
                                  .filter(
                                    (item) => item?.Whitelisted === "true"
                                  )
                                  .map((item, index) => (
                                    <option key={index} value={item?.fund_name}>
                                      {item?.fund_name}
                                    </option>
                                  ))}
                              </optgroup>
                              <optgroup label="Non-Whitelisted">
                                {amcNameList
                                  .filter(
                                    (item) => item?.Whitelisted === "false"
                                  )
                                  .map((item, index) => (
                                    <option key={index} value={item?.fund_name}>
                                      {item?.fund_name}
                                    </option>
                                  ))}
                              </optgroup>
                            </>
                          </Form.Select>
                          {errors.restartfundname && (
                            <small className="text-danger">
                              {errors.restartfundname.message}
                            </small>
                          )}
                        </Form.Group>

                        {/* Goal Name */}
                        <Form.Group className="mb-3">
                          <Form.Label htmlFor="goalNameSIP">
                            Goal Name
                          </Form.Label>
                          <Form.Control
                            id="goalNameSIP"
                            type="text"
                            readOnly
                            {...register("goalNameSIP", {
                              required: "Goal Name is required.",
                            })}
                          ></Form.Control>
                          {errors.goalNameSIP && (
                            <small className="text-danger">
                              {errors.goalNameSIP.message}
                            </small>
                          )}
                        </Form.Group>

                        {/* SIP Start Date */}
                        <Form.Group controlId="sipStartDate" className="mb-3">
                          <Form.Label className="d-block">
                            SIP Start Date
                          </Form.Label>
                          <Controller
                            name="sipStartDate"
                            control={control}
                            rules={{
                              required: "SIP Start Date is required.",
                            }}
                            render={({ field }) => (
                              <DatePicker
                                className="form-control w-100 "
                                dateFormat="dd-MM-yyyy"
                                placeholderText="SIP Start Date"
                                selected={field.value}
                                onChange={field.onChange}
                                minDate={new Date()}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                              />
                            )}
                          />
                          {errors.sipStartDate && (
                            <small className="text-danger">
                              {errors.sipStartDate.message}
                            </small>
                          )}
                        </Form.Group>

                        {/* Sip Amount */}
                        <Form.Group className="mb-3">
                          <Form.Label htmlFor="sipAmount">
                            SIP Amount
                          </Form.Label>

                          <Form.Control
                            type="number"
                            id="sipAmount"
                            placeholder="Enter SIP Amount"
                            {...register("sipAmountSIP", {
                              required: "Sip Amountis required.",
                              min: {
                                value: 1,
                                message: "Amount must be at least 1.",
                              },
                            })}
                          />
                          {errors.sipAmountSIP && (
                            <small className="text-danger">
                              {errors.sipAmountSIP.message}
                            </small>
                          )}
                        </Form.Group>

                        {/* Perpetual SIP */}
                        <Form.Group className="mb-3">
                          <Form.Label htmlFor="perpetualSIP">
                            Perpetual SIP?
                          </Form.Label>
                          <Form.Select
                            id="perpetualSIP"
                            {...register("perpetualSIP", {
                              required: "Perpetual SIP required",
                            })}
                          >
                            <option value="">Select</option>
                            <option value="yes">Yes</option>
                            <option value="no">No</option>
                          </Form.Select>
                          {errors.perpetualSIP && (
                            <small className="text-danger">
                              {errors.perpetualSIP.message}
                            </small>
                          )}
                        </Form.Group>

                        {perpetualSIPW === "no" && (
                          <>
                            {/* SIP End Date */}
                            <Form.Group controlId="sipEndDate" className="mb-3">
                              <Form.Label className="d-block">
                                SIP End Date
                              </Form.Label>
                              <Controller
                                name="sipEndDate"
                                control={control}
                                rules={{
                                  required: "SIP End Date is required.",
                                }}
                                render={({ field }) => (
                                  <DatePicker
                                    className="form-control w-100 "
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText="SIP End Date"
                                    selected={field.value}
                                    onChange={field.onChange}
                                    minDate={new Date()}
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                  />
                                )}
                              />
                              {errors.sipEndDate && (
                                <small className="text-danger">
                                  {errors.sipEndDate.message}
                                </small>
                              )}
                            </Form.Group>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
            </>
          )}

          {/* Submit Button */}
          <Button
            variant="success"
            type="submit"
            className="w-100"
            // disabled={!isValid}
          >
            Update
          </Button>
        </Form>
      </Modal.Body>
      {/* <Modal.Footer>
        <button
          className="lrgbutton uppercase w-100 text-white"
          type="submit"
          onClick={handleSubmit(onSubmit)}
          disabled={!isValid}
        >
          {update ? <Spinner size="sm" animation="border" /> : "Update"}
        </button>
      </Modal.Footer> */}
    </Modal>
  );
};

export default ExternalInvSwitchModal;
